import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Choice = {
  __typename?: 'Choice';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  translation?: Maybe<Array<Maybe<ComponentI18NTranslation>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ChoiceTranslationArgs = {
  filters?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChoiceEntityResponseCollection = {
  __typename?: 'ChoiceEntityResponseCollection';
  nodes: Array<Choice>;
  pageInfo: Pagination;
};

export type ChoiceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ChoiceFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ChoiceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ChoiceFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  translation?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ChoiceInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NTranslationInput>>>;
};

export type ChoiceRelationResponseCollection = {
  __typename?: 'ChoiceRelationResponseCollection';
  nodes: Array<Choice>;
};

export type ChoicesList = {
  __typename?: 'ChoicesList';
  choices: Array<Maybe<Choice>>;
  choices_connection?: Maybe<ChoiceRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ChoicesListChoicesArgs = {
  filters?: InputMaybe<ChoiceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChoicesListChoices_ConnectionArgs = {
  filters?: InputMaybe<ChoiceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChoicesListEntityResponseCollection = {
  __typename?: 'ChoicesListEntityResponseCollection';
  nodes: Array<ChoicesList>;
  pageInfo: Pagination;
};

export type ChoicesListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ChoicesListFiltersInput>>>;
  choices?: InputMaybe<ChoiceFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ChoicesListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ChoicesListFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ChoicesListInput = {
  choices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentArApplicationRequirement = {
  __typename?: 'ComponentArApplicationRequirement';
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  footnotes?: Maybe<Array<Maybe<ComponentCommonFootnote>>>;
  id: Scalars['ID']['output'];
  sub_chapter?: Maybe<Array<Maybe<ComponentArApplicationRequirementSubChapter>>>;
  translation?: Maybe<Array<Maybe<ComponentI18NRichTranslation>>>;
};


export type ComponentArApplicationRequirementDatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentArApplicationRequirementDatapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentArApplicationRequirementFootnotesArgs = {
  filters?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentArApplicationRequirementSub_ChapterArgs = {
  filters?: InputMaybe<ComponentArApplicationRequirementSubChapterFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentArApplicationRequirementTranslationArgs = {
  filters?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentArApplicationRequirementFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentArApplicationRequirementFiltersInput>>>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  footnotes?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  not?: InputMaybe<ComponentArApplicationRequirementFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArApplicationRequirementFiltersInput>>>;
  sub_chapter?: InputMaybe<ComponentArApplicationRequirementSubChapterFiltersInput>;
  translation?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
};

export type ComponentArApplicationRequirementInput = {
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  footnotes?: InputMaybe<Array<InputMaybe<ComponentCommonFootnoteInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sub_chapter?: InputMaybe<Array<InputMaybe<ComponentArApplicationRequirementSubChapterInput>>>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NRichTranslationInput>>>;
};

export type ComponentArApplicationRequirementSubChapter = {
  __typename?: 'ComponentArApplicationRequirementSubChapter';
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  footnotes?: Maybe<Array<Maybe<ComponentCommonFootnote>>>;
  id: Scalars['ID']['output'];
  translation?: Maybe<Array<Maybe<ComponentI18NRichTranslation>>>;
};


export type ComponentArApplicationRequirementSubChapterDatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentArApplicationRequirementSubChapterDatapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentArApplicationRequirementSubChapterFootnotesArgs = {
  filters?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentArApplicationRequirementSubChapterTranslationArgs = {
  filters?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentArApplicationRequirementSubChapterFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentArApplicationRequirementSubChapterFiltersInput>>>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  footnotes?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  not?: InputMaybe<ComponentArApplicationRequirementSubChapterFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArApplicationRequirementSubChapterFiltersInput>>>;
  translation?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
};

export type ComponentArApplicationRequirementSubChapterInput = {
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  footnotes?: InputMaybe<Array<InputMaybe<ComponentCommonFootnoteInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NRichTranslationInput>>>;
};

export type ComponentCommonFootnote = {
  __typename?: 'ComponentCommonFootnote';
  id: Scalars['ID']['output'];
  translation?: Maybe<Array<Maybe<ComponentI18NRichTranslation>>>;
};


export type ComponentCommonFootnoteTranslationArgs = {
  filters?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonFootnoteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonFootnoteFiltersInput>>>;
  not?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonFootnoteFiltersInput>>>;
  translation?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
};

export type ComponentCommonFootnoteInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NRichTranslationInput>>>;
};

export type ComponentDrConditionalDatapoints = {
  __typename?: 'ComponentDrConditionalDatapoints';
  id: Scalars['ID']['output'];
  indicator?: Maybe<Indicator>;
  no?: Maybe<Array<Maybe<ComponentDrDatapointGroup>>>;
  yes?: Maybe<Array<Maybe<ComponentDrDatapointGroup>>>;
};


export type ComponentDrConditionalDatapointsNoArgs = {
  filters?: InputMaybe<ComponentDrDatapointGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrConditionalDatapointsYesArgs = {
  filters?: InputMaybe<ComponentDrDatapointGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDrConditionalDatapointsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDrConditionalDatapointsFiltersInput>>>;
  indicator?: InputMaybe<IndicatorFiltersInput>;
  no?: InputMaybe<ComponentDrDatapointGroupFiltersInput>;
  not?: InputMaybe<ComponentDrConditionalDatapointsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDrConditionalDatapointsFiltersInput>>>;
  yes?: InputMaybe<ComponentDrDatapointGroupFiltersInput>;
};

export type ComponentDrConditionalDatapointsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  indicator?: InputMaybe<Scalars['ID']['input']>;
  no?: InputMaybe<Array<InputMaybe<ComponentDrDatapointGroupInput>>>;
  yes?: InputMaybe<Array<InputMaybe<ComponentDrDatapointGroupInput>>>;
};

export type ComponentDrDatapointGroup = {
  __typename?: 'ComponentDrDatapointGroup';
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  dimension?: Maybe<Dimension>;
  id: Scalars['ID']['output'];
};


export type ComponentDrDatapointGroupDatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrDatapointGroupDatapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDrDatapointGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDrDatapointGroupFiltersInput>>>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  dimension?: InputMaybe<DimensionFiltersInput>;
  not?: InputMaybe<ComponentDrDatapointGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDrDatapointGroupFiltersInput>>>;
};

export type ComponentDrDatapointGroupInput = {
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dimension?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDrDrContent = {
  __typename?: 'ComponentDrDrContent';
  dr_level_2?: Maybe<Array<Maybe<ComponentDrDrContentLevel2>>>;
  id: Scalars['ID']['output'];
};


export type ComponentDrDrContentDr_Level_2Args = {
  filters?: InputMaybe<ComponentDrDrContentLevel2FiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDrDrContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDrDrContentFiltersInput>>>;
  dr_level_2?: InputMaybe<ComponentDrDrContentLevel2FiltersInput>;
  not?: InputMaybe<ComponentDrDrContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDrDrContentFiltersInput>>>;
};

export type ComponentDrDrContentInput = {
  dr_level_2?: InputMaybe<Array<InputMaybe<ComponentDrDrContentLevel2Input>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDrDrContentLevel2 = {
  __typename?: 'ComponentDrDrContentLevel2';
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  dr_level_3?: Maybe<Array<Maybe<ComponentDrDrContentLevel3>>>;
  footnotes?: Maybe<Array<Maybe<ComponentCommonFootnote>>>;
  id: Scalars['ID']['output'];
  translation?: Maybe<Array<Maybe<ComponentI18NRichTranslation>>>;
};


export type ComponentDrDrContentLevel2DatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrDrContentLevel2Datapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrDrContentLevel2Dr_Level_3Args = {
  filters?: InputMaybe<ComponentDrDrContentLevel3FiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrDrContentLevel2FootnotesArgs = {
  filters?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrDrContentLevel2TranslationArgs = {
  filters?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDrDrContentLevel2FiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDrDrContentLevel2FiltersInput>>>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  dr_level_3?: InputMaybe<ComponentDrDrContentLevel3FiltersInput>;
  footnotes?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  not?: InputMaybe<ComponentDrDrContentLevel2FiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDrDrContentLevel2FiltersInput>>>;
  translation?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
};

export type ComponentDrDrContentLevel2Input = {
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dr_level_3?: InputMaybe<Array<InputMaybe<ComponentDrDrContentLevel3Input>>>;
  footnotes?: InputMaybe<Array<InputMaybe<ComponentCommonFootnoteInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NRichTranslationInput>>>;
};

export type ComponentDrDrContentLevel3 = {
  __typename?: 'ComponentDrDrContentLevel3';
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  footnotes?: Maybe<Array<Maybe<ComponentCommonFootnote>>>;
  id: Scalars['ID']['output'];
  translation?: Maybe<Array<Maybe<ComponentI18NRichTranslation>>>;
};


export type ComponentDrDrContentLevel3DatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrDrContentLevel3Datapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrDrContentLevel3FootnotesArgs = {
  filters?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrDrContentLevel3TranslationArgs = {
  filters?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDrDrContentLevel3FiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDrDrContentLevel3FiltersInput>>>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  footnotes?: InputMaybe<ComponentCommonFootnoteFiltersInput>;
  not?: InputMaybe<ComponentDrDrContentLevel3FiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDrDrContentLevel3FiltersInput>>>;
  translation?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
};

export type ComponentDrDrContentLevel3Input = {
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  footnotes?: InputMaybe<Array<InputMaybe<ComponentCommonFootnoteInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NRichTranslationInput>>>;
};

export type ComponentDrIndicatorDrivenDatapoints = {
  __typename?: 'ComponentDrIndicatorDrivenDatapoints';
  condition?: Maybe<ComponentDrConditionalDatapoints>;
  id: Scalars['ID']['output'];
  unconditionals: Array<Maybe<Datapoint>>;
  unconditionals_connection?: Maybe<DatapointRelationResponseCollection>;
};


export type ComponentDrIndicatorDrivenDatapointsUnconditionalsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentDrIndicatorDrivenDatapointsUnconditionals_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDrIndicatorDrivenDatapointsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDrIndicatorDrivenDatapointsFiltersInput>>>;
  condition?: InputMaybe<ComponentDrConditionalDatapointsFiltersInput>;
  not?: InputMaybe<ComponentDrIndicatorDrivenDatapointsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDrIndicatorDrivenDatapointsFiltersInput>>>;
  unconditionals?: InputMaybe<DatapointFiltersInput>;
};

export type ComponentDrIndicatorDrivenDatapointsInput = {
  condition?: InputMaybe<ComponentDrConditionalDatapointsInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  unconditionals?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ComponentGuidanceGuidance = {
  __typename?: 'ComponentGuidanceGuidance';
  id: Scalars['ID']['output'];
  translation?: Maybe<Array<Maybe<ComponentI18NRichTranslation>>>;
};


export type ComponentGuidanceGuidanceTranslationArgs = {
  filters?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentGuidanceGuidanceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGuidanceGuidanceFiltersInput>>>;
  not?: InputMaybe<ComponentGuidanceGuidanceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGuidanceGuidanceFiltersInput>>>;
  translation?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
};

export type ComponentGuidanceGuidanceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NRichTranslationInput>>>;
};

export type ComponentI18NRichTranslation = {
  __typename?: 'ComponentI18NRichTranslation';
  content?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  language: Enum_Componenti18Nrichtranslation_Language;
};

export type ComponentI18NRichTranslationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentI18NRichTranslationFiltersInput>>>;
  content?: InputMaybe<JsonFilterInput>;
  language?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentI18NRichTranslationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentI18NRichTranslationFiltersInput>>>;
};

export type ComponentI18NRichTranslationInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Enum_Componenti18Nrichtranslation_Language>;
};

export type ComponentI18NTranslation = {
  __typename?: 'ComponentI18NTranslation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: Enum_Componenti18Ntranslation_Language;
  name?: Maybe<Scalars['String']['output']>;
};

export type ComponentI18NTranslationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentI18NTranslationFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  language?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentI18NTranslationFiltersInput>>>;
};

export type ComponentI18NTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Enum_Componenti18Ntranslation_Language>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMdrMdrLevel1 = {
  __typename?: 'ComponentMdrMdrLevel1';
  application_requirements?: Maybe<Array<Maybe<ComponentArApplicationRequirement>>>;
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  id: Scalars['ID']['output'];
  mdr_level_2?: Maybe<Array<Maybe<ComponentMdrMdrLevel2>>>;
};


export type ComponentMdrMdrLevel1Application_RequirementsArgs = {
  filters?: InputMaybe<ComponentArApplicationRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentMdrMdrLevel1DatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentMdrMdrLevel1Datapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentMdrMdrLevel1Mdr_Level_2Args = {
  filters?: InputMaybe<ComponentMdrMdrLevel2FiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMdrMdrLevel1FiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMdrMdrLevel1FiltersInput>>>;
  application_requirements?: InputMaybe<ComponentArApplicationRequirementFiltersInput>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  mdr_level_2?: InputMaybe<ComponentMdrMdrLevel2FiltersInput>;
  not?: InputMaybe<ComponentMdrMdrLevel1FiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMdrMdrLevel1FiltersInput>>>;
};

export type ComponentMdrMdrLevel1Input = {
  application_requirements?: InputMaybe<Array<InputMaybe<ComponentArApplicationRequirementInput>>>;
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mdr_level_2?: InputMaybe<Array<InputMaybe<ComponentMdrMdrLevel2Input>>>;
};

export type ComponentMdrMdrLevel2 = {
  __typename?: 'ComponentMdrMdrLevel2';
  content?: Maybe<Scalars['JSON']['output']>;
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  id: Scalars['ID']['output'];
  mdr_level_3?: Maybe<Array<Maybe<ComponentMdrMdrLevel3>>>;
};


export type ComponentMdrMdrLevel2DatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentMdrMdrLevel2Datapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentMdrMdrLevel2Mdr_Level_3Args = {
  filters?: InputMaybe<ComponentMdrMdrLevel3FiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMdrMdrLevel2FiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMdrMdrLevel2FiltersInput>>>;
  content?: InputMaybe<JsonFilterInput>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  mdr_level_3?: InputMaybe<ComponentMdrMdrLevel3FiltersInput>;
  not?: InputMaybe<ComponentMdrMdrLevel2FiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMdrMdrLevel2FiltersInput>>>;
};

export type ComponentMdrMdrLevel2Input = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mdr_level_3?: InputMaybe<Array<InputMaybe<ComponentMdrMdrLevel3Input>>>;
};

export type ComponentMdrMdrLevel3 = {
  __typename?: 'ComponentMdrMdrLevel3';
  content?: Maybe<Scalars['JSON']['output']>;
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  id: Scalars['ID']['output'];
};


export type ComponentMdrMdrLevel3DatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentMdrMdrLevel3Datapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMdrMdrLevel3FiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMdrMdrLevel3FiltersInput>>>;
  content?: InputMaybe<JsonFilterInput>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  not?: InputMaybe<ComponentMdrMdrLevel3FiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMdrMdrLevel3FiltersInput>>>;
};

export type ComponentMdrMdrLevel3Input = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Datapoint = {
  __typename?: 'Datapoint';
  alternative?: Maybe<Scalars['Boolean']['output']>;
  ar?: Maybe<Scalars['String']['output']>;
  conditional?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defineDimensionItemsOf?: Maybe<Dimension>;
  documentId: Scalars['ID']['output'];
  dr?: Maybe<Scalars['String']['output']>;
  esrs?: Maybe<Topic>;
  identifier?: Maybe<Scalars['String']['output']>;
  indicators: Array<Maybe<Indicator>>;
  indicators_connection?: Maybe<IndicatorRelationResponseCollection>;
  paragraph?: Maybe<Scalars['String']['output']>;
  phasein_all?: Maybe<Scalars['String']['output']>;
  phasein_less750?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related_datapoints: Array<Maybe<Datapoint>>;
  related_datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  slug?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Array<Maybe<ComponentI18NTranslation>>>;
  type?: Maybe<Enum_Datapoint_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  voluntary?: Maybe<Scalars['Boolean']['output']>;
};


export type DatapointIndicatorsArgs = {
  filters?: InputMaybe<IndicatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DatapointIndicators_ConnectionArgs = {
  filters?: InputMaybe<IndicatorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DatapointRelated_DatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DatapointRelated_Datapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DatapointTranslationArgs = {
  filters?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DatapointEntityResponseCollection = {
  __typename?: 'DatapointEntityResponseCollection';
  nodes: Array<Datapoint>;
  pageInfo: Pagination;
};

export type DatapointFiltersInput = {
  alternative?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<DatapointFiltersInput>>>;
  ar?: InputMaybe<StringFilterInput>;
  conditional?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  defineDimensionItemsOf?: InputMaybe<DimensionFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  dr?: InputMaybe<StringFilterInput>;
  esrs?: InputMaybe<TopicFiltersInput>;
  identifier?: InputMaybe<StringFilterInput>;
  indicators?: InputMaybe<IndicatorFiltersInput>;
  not?: InputMaybe<DatapointFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DatapointFiltersInput>>>;
  paragraph?: InputMaybe<StringFilterInput>;
  phasein_all?: InputMaybe<StringFilterInput>;
  phasein_less750?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  related_datapoints?: InputMaybe<DatapointFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  translation?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  voluntary?: InputMaybe<BooleanFilterInput>;
};

export type DatapointInput = {
  alternative?: InputMaybe<Scalars['Boolean']['input']>;
  ar?: InputMaybe<Scalars['String']['input']>;
  conditional?: InputMaybe<Scalars['Boolean']['input']>;
  defineDimensionItemsOf?: InputMaybe<Scalars['ID']['input']>;
  dr?: InputMaybe<Scalars['String']['input']>;
  esrs?: InputMaybe<Scalars['ID']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  indicators?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
  phasein_all?: InputMaybe<Scalars['String']['input']>;
  phasein_less750?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  related_datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NTranslationInput>>>;
  type?: InputMaybe<Enum_Datapoint_Type>;
  voluntary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DatapointRelationResponseCollection = {
  __typename?: 'DatapointRelationResponseCollection';
  nodes: Array<Datapoint>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID']['output'];
};

export type Dimension = {
  __typename?: 'Dimension';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dimension_items: Array<Maybe<DimensionItem>>;
  dimension_items_connection?: Maybe<DimensionItemRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Dimension>>;
  localizations_connection?: Maybe<DimensionRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DimensionDimension_ItemsArgs = {
  filters?: InputMaybe<DimensionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DimensionDimension_Items_ConnectionArgs = {
  filters?: InputMaybe<DimensionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DimensionLocalizationsArgs = {
  filters?: InputMaybe<DimensionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DimensionLocalizations_ConnectionArgs = {
  filters?: InputMaybe<DimensionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DimensionEntityResponseCollection = {
  __typename?: 'DimensionEntityResponseCollection';
  nodes: Array<Dimension>;
  pageInfo: Pagination;
};

export type DimensionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DimensionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  dimension_items?: InputMaybe<DimensionItemFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<DimensionFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DimensionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DimensionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DimensionInput = {
  dimension_items?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type DimensionItem = {
  __typename?: 'DimensionItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dimension?: Maybe<Dimension>;
  documentId: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<DimensionItem>>;
  localizations_connection?: Maybe<DimensionItemRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DimensionItemLocalizationsArgs = {
  filters?: InputMaybe<DimensionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DimensionItemLocalizations_ConnectionArgs = {
  filters?: InputMaybe<DimensionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DimensionItemEntityResponseCollection = {
  __typename?: 'DimensionItemEntityResponseCollection';
  nodes: Array<DimensionItem>;
  pageInfo: Pagination;
};

export type DimensionItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DimensionItemFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  dimension?: InputMaybe<DimensionFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<DimensionItemFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DimensionItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DimensionItemFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DimensionItemInput = {
  dimension?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type DimensionItemRelationResponseCollection = {
  __typename?: 'DimensionItemRelationResponseCollection';
  nodes: Array<DimensionItem>;
};

export type DimensionRelationResponseCollection = {
  __typename?: 'DimensionRelationResponseCollection';
  nodes: Array<Dimension>;
};

export type DisclosureRequirement = {
  __typename?: 'DisclosureRequirement';
  application_requirements?: Maybe<Array<Maybe<ComponentArApplicationRequirement>>>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<ComponentDrDrContent>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  datapoints?: Maybe<Array<Maybe<ComponentDrIndicatorDrivenDatapoints>>>;
  documentId: Scalars['ID']['output'];
  esrs?: Maybe<Topic>;
  guidances?: Maybe<Array<Maybe<ComponentGuidanceGuidance>>>;
  minimum_disclosure_requirements: Array<Maybe<Mdr>>;
  minimum_disclosure_requirements_connection?: Maybe<MdrRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  standard_requirement: Array<Maybe<StandardRequirement>>;
  standard_requirement_connection?: Maybe<StandardRequirementRelationResponseCollection>;
  translation?: Maybe<Array<Maybe<ComponentI18NTranslation>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DisclosureRequirementApplication_RequirementsArgs = {
  filters?: InputMaybe<ComponentArApplicationRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DisclosureRequirementDatapointsArgs = {
  filters?: InputMaybe<ComponentDrIndicatorDrivenDatapointsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DisclosureRequirementGuidancesArgs = {
  filters?: InputMaybe<ComponentGuidanceGuidanceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DisclosureRequirementMinimum_Disclosure_RequirementsArgs = {
  filters?: InputMaybe<MdrFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DisclosureRequirementMinimum_Disclosure_Requirements_ConnectionArgs = {
  filters?: InputMaybe<MdrFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DisclosureRequirementStandard_RequirementArgs = {
  filters?: InputMaybe<StandardRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DisclosureRequirementStandard_Requirement_ConnectionArgs = {
  filters?: InputMaybe<StandardRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DisclosureRequirementTranslationArgs = {
  filters?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DisclosureRequirementEntityResponseCollection = {
  __typename?: 'DisclosureRequirementEntityResponseCollection';
  nodes: Array<DisclosureRequirement>;
  pageInfo: Pagination;
};

export type DisclosureRequirementFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DisclosureRequirementFiltersInput>>>;
  application_requirements?: InputMaybe<ComponentArApplicationRequirementFiltersInput>;
  code?: InputMaybe<StringFilterInput>;
  content?: InputMaybe<ComponentDrDrContentFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  datapoints?: InputMaybe<ComponentDrIndicatorDrivenDatapointsFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  esrs?: InputMaybe<TopicFiltersInput>;
  guidances?: InputMaybe<ComponentGuidanceGuidanceFiltersInput>;
  minimum_disclosure_requirements?: InputMaybe<MdrFiltersInput>;
  not?: InputMaybe<DisclosureRequirementFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DisclosureRequirementFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  standard_requirement?: InputMaybe<StandardRequirementFiltersInput>;
  translation?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DisclosureRequirementInput = {
  application_requirements?: InputMaybe<Array<InputMaybe<ComponentArApplicationRequirementInput>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ComponentDrDrContentInput>;
  datapoints?: InputMaybe<Array<InputMaybe<ComponentDrIndicatorDrivenDatapointsInput>>>;
  esrs?: InputMaybe<Scalars['ID']['input']>;
  guidances?: InputMaybe<Array<InputMaybe<ComponentGuidanceGuidanceInput>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  minimum_disclosure_requirements?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  standard_requirement?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NTranslationInput>>>;
};

export type DisclosureRequirementRelationResponseCollection = {
  __typename?: 'DisclosureRequirementRelationResponseCollection';
  nodes: Array<DisclosureRequirement>;
};

export enum Enum_Componenti18Nrichtranslation_Language {
  En = 'en',
  Fr = 'fr'
}

export enum Enum_Componenti18Ntranslation_Language {
  En = 'en',
  Fr = 'fr'
}

export enum Enum_Datapoint_Type {
  Area = 'area',
  Date = 'date',
  Decimal = 'decimal',
  DecimalPercentNarrative = 'decimal_percent_narrative',
  Energy = 'energy',
  Ghgemissions = 'ghgemissions',
  Gyear = 'gyear',
  Integer = 'integer',
  IntegerPercentage = 'integer_percentage',
  Intensity = 'intensity',
  Mass = 'mass',
  MdrA = 'mdr_a',
  MdrNoA = 'mdr_no_a',
  MdrNoP = 'mdr_no_p',
  MdrNoPta = 'mdr_no_pta',
  MdrNoT = 'mdr_no_t',
  MdrP = 'mdr_p',
  MdrT = 'mdr_t',
  Monetary = 'monetary',
  Narrative = 'narrative',
  NarrativeMonetary = 'narrative_monetary',
  NarrativeNumerical = 'narrative_numerical',
  Percent = 'percent',
  SemiNarrative = 'semi_narrative',
  Table = 'table',
  Table_1 = 'table_1',
  Table_1Decimal = 'table_1_decimal',
  Table_2 = 'table_2',
  Table_2Decimal = 'table_2_decimal',
  Table_3 = 'table_3',
  Table_3Decimal = 'table_3_decimal',
  Table_4 = 'table_4',
  Table_4DecimalInteger = 'table_4_decimal_integer',
  TableDecimal = 'table_decimal',
  TableGhgemissions = 'table_ghgemissions',
  TableInteger = 'table_integer',
  TableMass = 'table_mass',
  TableMonetary = 'table_monetary',
  TableNarrative = 'table_narrative',
  TableNumerical = 'table_numerical',
  TablePercent = 'table_percent',
  TablePercentage = 'table_percentage',
  TableSemiNarrative = 'table_semi_narrative',
  TableVolume = 'table_volume',
  Volume = 'volume'
}

export enum Enum_Indicator_Type {
  Boolean = 'boolean',
  Date = 'date',
  MultipleChoice = 'multiple_choice',
  Narrative = 'narrative',
  Number = 'number',
  Percentage = 'percentage',
  SimpleChoice = 'simple_choice'
}

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = Choice | ChoicesList | ComponentArApplicationRequirement | ComponentArApplicationRequirementSubChapter | ComponentCommonFootnote | ComponentDrConditionalDatapoints | ComponentDrDatapointGroup | ComponentDrDrContent | ComponentDrDrContentLevel2 | ComponentDrDrContentLevel3 | ComponentDrIndicatorDrivenDatapoints | ComponentGuidanceGuidance | ComponentI18NRichTranslation | ComponentI18NTranslation | ComponentMdrMdrLevel1 | ComponentMdrMdrLevel2 | ComponentMdrMdrLevel3 | Datapoint | Dimension | DimensionItem | DisclosureRequirement | I18NLocale | Indicator | Mdr | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | Standard | StandardRequirement | Topic | Unit | UnitType | UploadFile | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type Indicator = {
  __typename?: 'Indicator';
  choices_list?: Maybe<ChoicesList>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointRelationResponseCollection>;
  dimensions: Array<Maybe<Dimension>>;
  dimensions_connection?: Maybe<DimensionRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  splitByOrganizationUnit?: Maybe<Scalars['Boolean']['output']>;
  translation?: Maybe<Array<Maybe<ComponentI18NTranslation>>>;
  type?: Maybe<Enum_Indicator_Type>;
  unit?: Maybe<Unit>;
  unit_type?: Maybe<UnitType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type IndicatorDatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type IndicatorDatapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type IndicatorDimensionsArgs = {
  filters?: InputMaybe<DimensionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type IndicatorDimensions_ConnectionArgs = {
  filters?: InputMaybe<DimensionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type IndicatorTranslationArgs = {
  filters?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IndicatorEntityResponseCollection = {
  __typename?: 'IndicatorEntityResponseCollection';
  nodes: Array<Indicator>;
  pageInfo: Pagination;
};

export type IndicatorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IndicatorFiltersInput>>>;
  choices_list?: InputMaybe<ChoicesListFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  datapoints?: InputMaybe<DatapointFiltersInput>;
  dimensions?: InputMaybe<DimensionFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<IndicatorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IndicatorFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  splitByOrganizationUnit?: InputMaybe<BooleanFilterInput>;
  translation?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  unit?: InputMaybe<UnitFiltersInput>;
  unit_type?: InputMaybe<UnitTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IndicatorInput = {
  choices_list?: InputMaybe<Scalars['ID']['input']>;
  datapoints?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  splitByOrganizationUnit?: InputMaybe<Scalars['Boolean']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NTranslationInput>>>;
  type?: InputMaybe<Enum_Indicator_Type>;
  unit?: InputMaybe<Scalars['ID']['input']>;
  unit_type?: InputMaybe<Scalars['ID']['input']>;
};

export type IndicatorRelationResponseCollection = {
  __typename?: 'IndicatorRelationResponseCollection';
  nodes: Array<Indicator>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Mdr = {
  __typename?: 'Mdr';
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<ComponentMdrMdrLevel1>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Mdr>>;
  localizations_connection?: Maybe<MdrRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MdrLocalizationsArgs = {
  filters?: InputMaybe<MdrFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MdrLocalizations_ConnectionArgs = {
  filters?: InputMaybe<MdrFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MdrEntityResponseCollection = {
  __typename?: 'MdrEntityResponseCollection';
  nodes: Array<Mdr>;
  pageInfo: Pagination;
};

export type MdrFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MdrFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  content?: InputMaybe<ComponentMdrMdrLevel1FiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<MdrFiltersInput>;
  not?: InputMaybe<MdrFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MdrFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MdrInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ComponentMdrMdrLevel1Input>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MdrRelationResponseCollection = {
  __typename?: 'MdrRelationResponseCollection';
  nodes: Array<Mdr>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createChoice?: Maybe<Choice>;
  createChoicesList?: Maybe<ChoicesList>;
  createDatapoint?: Maybe<Datapoint>;
  createDimension?: Maybe<Dimension>;
  createDimensionItem?: Maybe<DimensionItem>;
  createDisclosureRequirement?: Maybe<DisclosureRequirement>;
  createIndicator?: Maybe<Indicator>;
  createMdr?: Maybe<Mdr>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createStandard?: Maybe<Standard>;
  createStandardRequirement?: Maybe<StandardRequirement>;
  createTopic?: Maybe<Topic>;
  createUnit?: Maybe<Unit>;
  createUnitType?: Maybe<UnitType>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteChoice?: Maybe<DeleteMutationResponse>;
  deleteChoicesList?: Maybe<DeleteMutationResponse>;
  deleteDatapoint?: Maybe<DeleteMutationResponse>;
  deleteDimension?: Maybe<DeleteMutationResponse>;
  deleteDimensionItem?: Maybe<DeleteMutationResponse>;
  deleteDisclosureRequirement?: Maybe<DeleteMutationResponse>;
  deleteIndicator?: Maybe<DeleteMutationResponse>;
  deleteMdr?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteStandard?: Maybe<DeleteMutationResponse>;
  deleteStandardRequirement?: Maybe<DeleteMutationResponse>;
  deleteTopic?: Maybe<DeleteMutationResponse>;
  deleteUnit?: Maybe<DeleteMutationResponse>;
  deleteUnitType?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateChoice?: Maybe<Choice>;
  updateChoicesList?: Maybe<ChoicesList>;
  updateDatapoint?: Maybe<Datapoint>;
  updateDimension?: Maybe<Dimension>;
  updateDimensionItem?: Maybe<DimensionItem>;
  updateDisclosureRequirement?: Maybe<DisclosureRequirement>;
  updateIndicator?: Maybe<Indicator>;
  updateMdr?: Maybe<Mdr>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateStandard?: Maybe<Standard>;
  updateStandardRequirement?: Maybe<StandardRequirement>;
  updateTopic?: Maybe<Topic>;
  updateUnit?: Maybe<Unit>;
  updateUnitType?: Maybe<UnitType>;
  updateUploadFile: UploadFile;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateChoiceArgs = {
  data: ChoiceInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateChoicesListArgs = {
  data: ChoicesListInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateDatapointArgs = {
  data: DatapointInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateDimensionArgs = {
  data: DimensionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateDimensionItemArgs = {
  data: DimensionItemInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateDisclosureRequirementArgs = {
  data: DisclosureRequirementInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateIndicatorArgs = {
  data: IndicatorInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateMdrArgs = {
  data: MdrInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateStandardArgs = {
  data: StandardInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateStandardRequirementArgs = {
  data: StandardRequirementInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateTopicArgs = {
  data: TopicInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUnitArgs = {
  data: UnitInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUnitTypeArgs = {
  data: UnitTypeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteChoiceArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteChoicesListArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteDatapointArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteDimensionArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteDimensionItemArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteDisclosureRequirementArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteIndicatorArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteMdrArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteStandardArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteStandardRequirementArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteTopicArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUnitArgs = {
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUnitTypeArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateChoiceArgs = {
  data: ChoiceInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateChoicesListArgs = {
  data: ChoicesListInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateDatapointArgs = {
  data: DatapointInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateDimensionArgs = {
  data: DimensionInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateDimensionItemArgs = {
  data: DimensionItemInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateDisclosureRequirementArgs = {
  data: DisclosureRequirementInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateIndicatorArgs = {
  data: IndicatorInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateMdrArgs = {
  data: MdrInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateStandardArgs = {
  data: StandardInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateStandardRequirementArgs = {
  data: StandardRequirementInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateTopicArgs = {
  data: TopicInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUnitArgs = {
  data: UnitInput;
  documentId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUnitTypeArgs = {
  data: UnitTypeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export enum PublicationFilter {
  HasPublishedVersion = 'HAS_PUBLISHED_VERSION',
  HasPublishedVersionDocument = 'HAS_PUBLISHED_VERSION_DOCUMENT',
  Modified = 'MODIFIED',
  NeverPublished = 'NEVER_PUBLISHED',
  NeverPublishedDocument = 'NEVER_PUBLISHED_DOCUMENT',
  PublishedWithoutDraft = 'PUBLISHED_WITHOUT_DRAFT',
  PublishedWithDraft = 'PUBLISHED_WITH_DRAFT',
  Unmodified = 'UNMODIFIED'
}

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  choice?: Maybe<Choice>;
  choices: Array<Maybe<Choice>>;
  choicesList?: Maybe<ChoicesList>;
  choicesLists: Array<Maybe<ChoicesList>>;
  choicesLists_connection?: Maybe<ChoicesListEntityResponseCollection>;
  choices_connection?: Maybe<ChoiceEntityResponseCollection>;
  datapoint?: Maybe<Datapoint>;
  datapoints: Array<Maybe<Datapoint>>;
  datapoints_connection?: Maybe<DatapointEntityResponseCollection>;
  dimension?: Maybe<Dimension>;
  dimensionItem?: Maybe<DimensionItem>;
  dimensionItems: Array<Maybe<DimensionItem>>;
  dimensionItems_connection?: Maybe<DimensionItemEntityResponseCollection>;
  dimensions: Array<Maybe<Dimension>>;
  dimensions_connection?: Maybe<DimensionEntityResponseCollection>;
  disclosureRequirement?: Maybe<DisclosureRequirement>;
  disclosureRequirements: Array<Maybe<DisclosureRequirement>>;
  disclosureRequirements_connection?: Maybe<DisclosureRequirementEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  indicator?: Maybe<Indicator>;
  indicators: Array<Maybe<Indicator>>;
  indicators_connection?: Maybe<IndicatorEntityResponseCollection>;
  mdr?: Maybe<Mdr>;
  mdrs: Array<Maybe<Mdr>>;
  mdrs_connection?: Maybe<MdrEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  standard?: Maybe<Standard>;
  standardRequirement?: Maybe<StandardRequirement>;
  standardRequirements: Array<Maybe<StandardRequirement>>;
  standardRequirements_connection?: Maybe<StandardRequirementEntityResponseCollection>;
  standards: Array<Maybe<Standard>>;
  standards_connection?: Maybe<StandardEntityResponseCollection>;
  topic?: Maybe<Topic>;
  topics: Array<Maybe<Topic>>;
  topics_connection?: Maybe<TopicEntityResponseCollection>;
  unit?: Maybe<Unit>;
  unitType?: Maybe<UnitType>;
  unitTypes: Array<Maybe<UnitType>>;
  unitTypes_connection?: Maybe<UnitTypeEntityResponseCollection>;
  units: Array<Maybe<Unit>>;
  units_connection?: Maybe<UnitEntityResponseCollection>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryChoiceArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryChoicesArgs = {
  filters?: InputMaybe<ChoiceFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryChoicesListArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryChoicesListsArgs = {
  filters?: InputMaybe<ChoicesListFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryChoicesLists_ConnectionArgs = {
  filters?: InputMaybe<ChoicesListFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryChoices_ConnectionArgs = {
  filters?: InputMaybe<ChoiceFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDatapointArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDatapointsArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDatapoints_ConnectionArgs = {
  filters?: InputMaybe<DatapointFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDimensionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDimensionItemArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDimensionItemsArgs = {
  filters?: InputMaybe<DimensionItemFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDimensionItems_ConnectionArgs = {
  filters?: InputMaybe<DimensionItemFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDimensionsArgs = {
  filters?: InputMaybe<DimensionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDimensions_ConnectionArgs = {
  filters?: InputMaybe<DimensionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDisclosureRequirementArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDisclosureRequirementsArgs = {
  filters?: InputMaybe<DisclosureRequirementFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDisclosureRequirements_ConnectionArgs = {
  filters?: InputMaybe<DisclosureRequirementFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryIndicatorArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryIndicatorsArgs = {
  filters?: InputMaybe<IndicatorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryIndicators_ConnectionArgs = {
  filters?: InputMaybe<IndicatorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryMdrArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryMdrsArgs = {
  filters?: InputMaybe<MdrFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryMdrs_ConnectionArgs = {
  filters?: InputMaybe<MdrFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryStandardArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryStandardRequirementArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryStandardRequirementsArgs = {
  filters?: InputMaybe<StandardRequirementFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryStandardRequirements_ConnectionArgs = {
  filters?: InputMaybe<StandardRequirementFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryStandardsArgs = {
  filters?: InputMaybe<StandardFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryStandards_ConnectionArgs = {
  filters?: InputMaybe<StandardFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTopicArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTopicsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTopics_ConnectionArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUnitArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUnitTypeArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUnitTypesArgs = {
  filters?: InputMaybe<UnitTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUnitTypes_ConnectionArgs = {
  filters?: InputMaybe<UnitTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUnitsArgs = {
  filters?: InputMaybe<UnitFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUnits_ConnectionArgs = {
  filters?: InputMaybe<UnitFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type Standard = {
  __typename?: 'Standard';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  logo_base64?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  standard_requirements: Array<Maybe<StandardRequirement>>;
  standard_requirements_connection?: Maybe<StandardRequirementRelationResponseCollection>;
  topics: Array<Maybe<Topic>>;
  topics_connection?: Maybe<TopicRelationResponseCollection>;
  translation: ComponentI18NTranslation;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionNumber: Scalars['Float']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


export type StandardStandard_RequirementsArgs = {
  filters?: InputMaybe<StandardRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StandardStandard_Requirements_ConnectionArgs = {
  filters?: InputMaybe<StandardRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StandardTopicsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StandardTopics_ConnectionArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StandardEntityResponseCollection = {
  __typename?: 'StandardEntityResponseCollection';
  nodes: Array<Standard>;
  pageInfo: Pagination;
};

export type StandardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StandardFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  isPrivate?: InputMaybe<BooleanFilterInput>;
  logo_base64?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<StandardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StandardFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  standard_requirements?: InputMaybe<StandardRequirementFiltersInput>;
  topics?: InputMaybe<TopicFiltersInput>;
  translation?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  versionNumber?: InputMaybe<FloatFilterInput>;
  website?: InputMaybe<StringFilterInput>;
};

export type StandardInput = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  logo_base64?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  standard_requirements?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  translation?: InputMaybe<ComponentI18NTranslationInput>;
  versionNumber?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type StandardRequirement = {
  __typename?: 'StandardRequirement';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disclosure_requirements: Array<Maybe<DisclosureRequirement>>;
  disclosure_requirements_connection?: Maybe<DisclosureRequirementRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  standard?: Maybe<Standard>;
  topic?: Maybe<Topic>;
  translation?: Maybe<Array<Maybe<ComponentI18NTranslation>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type StandardRequirementDisclosure_RequirementsArgs = {
  filters?: InputMaybe<DisclosureRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StandardRequirementDisclosure_Requirements_ConnectionArgs = {
  filters?: InputMaybe<DisclosureRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StandardRequirementTranslationArgs = {
  filters?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StandardRequirementEntityResponseCollection = {
  __typename?: 'StandardRequirementEntityResponseCollection';
  nodes: Array<StandardRequirement>;
  pageInfo: Pagination;
};

export type StandardRequirementFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StandardRequirementFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  disclosure_requirements?: InputMaybe<DisclosureRequirementFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<StandardRequirementFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StandardRequirementFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  standard?: InputMaybe<StandardFiltersInput>;
  topic?: InputMaybe<TopicFiltersInput>;
  translation?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type StandardRequirementInput = {
  disclosure_requirements?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  standard?: InputMaybe<Scalars['ID']['input']>;
  topic?: InputMaybe<Scalars['ID']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NTranslationInput>>>;
};

export type StandardRequirementRelationResponseCollection = {
  __typename?: 'StandardRequirementRelationResponseCollection';
  nodes: Array<StandardRequirement>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Topic = {
  __typename?: 'Topic';
  children: Array<Maybe<Topic>>;
  children_connection?: Maybe<TopicRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  disclosure_requirements: Array<Maybe<DisclosureRequirement>>;
  disclosure_requirements_connection?: Maybe<DisclosureRequirementRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Topic>>;
  localizations_connection?: Maybe<TopicRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<Topic>;
  position?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  standard?: Maybe<Standard>;
  standard_requirement?: Maybe<StandardRequirement>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TopicChildrenArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TopicChildren_ConnectionArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TopicDisclosure_RequirementsArgs = {
  filters?: InputMaybe<DisclosureRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TopicDisclosure_Requirements_ConnectionArgs = {
  filters?: InputMaybe<DisclosureRequirementFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TopicLocalizationsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TopicLocalizations_ConnectionArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TopicEntityResponseCollection = {
  __typename?: 'TopicEntityResponseCollection';
  nodes: Array<Topic>;
  pageInfo: Pagination;
};

export type TopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TopicFiltersInput>>>;
  children?: InputMaybe<TopicFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<JsonFilterInput>;
  disclosure_requirements?: InputMaybe<DisclosureRequirementFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<TopicFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TopicFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TopicFiltersInput>>>;
  parent?: InputMaybe<TopicFiltersInput>;
  position?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  standard?: InputMaybe<StandardFiltersInput>;
  standard_requirement?: InputMaybe<StandardRequirementFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TopicInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  disclosure_requirements?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  standard?: InputMaybe<Scalars['ID']['input']>;
  standard_requirement?: InputMaybe<Scalars['ID']['input']>;
};

export type TopicRelationResponseCollection = {
  __typename?: 'TopicRelationResponseCollection';
  nodes: Array<Topic>;
};

export type Unit = {
  __typename?: 'Unit';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations: Array<Maybe<Unit>>;
  localizations_connection?: Maybe<UnitRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  unit_type?: Maybe<UnitType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UnitLocalizationsArgs = {
  filters?: InputMaybe<UnitFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UnitLocalizations_ConnectionArgs = {
  filters?: InputMaybe<UnitFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UnitEntityResponseCollection = {
  __typename?: 'UnitEntityResponseCollection';
  nodes: Array<Unit>;
  pageInfo: Pagination;
};

export type UnitFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UnitFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  identifier?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<UnitFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UnitFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UnitFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  symbol?: InputMaybe<StringFilterInput>;
  unit_type?: InputMaybe<UnitTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UnitInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  unit_type?: InputMaybe<Scalars['ID']['input']>;
};

export type UnitRelationResponseCollection = {
  __typename?: 'UnitRelationResponseCollection';
  nodes: Array<Unit>;
};

export type UnitType = {
  __typename?: 'UnitType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  translation?: Maybe<Array<Maybe<ComponentI18NTranslation>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UnitTypeTranslationArgs = {
  filters?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UnitTypeEntityResponseCollection = {
  __typename?: 'UnitTypeEntityResponseCollection';
  nodes: Array<UnitType>;
  pageInfo: Pagination;
};

export type UnitTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UnitTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  identifier?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UnitTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UnitTypeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  translation?: InputMaybe<ComponentI18NTranslationFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UnitTypeInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<Array<InputMaybe<ComponentI18NTranslationInput>>>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  focalPoint?: InputMaybe<JsonFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type DatapointTags_Datapoint_StrapiFragment = { __typename?: 'Datapoint', documentId: string, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null };

export type EnterpriseStandardsEditor_StandardsQueryVariables = Exact<{ [key: string]: never; }>;


export type EnterpriseStandardsEditor_StandardsQuery = { __typename?: 'Query', standards: Array<{ __typename?: 'Standard', name?: string | null, slug: string, isPrivate?: boolean | null, translation: { __typename?: 'ComponentI18NTranslation', id: string, description?: string | null, language: Enum_Componenti18Ntranslation_Language, name?: string | null } } | null> };

export type EnterpriseStandardsEditor_StandardFragment = { __typename?: 'Standard', name?: string | null, slug: string, isPrivate?: boolean | null, translation: { __typename?: 'ComponentI18NTranslation', id: string, description?: string | null, language: Enum_Componenti18Ntranslation_Language, name?: string | null } };

export type DimensionTableStrapiQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type DimensionTableStrapiQuery = { __typename?: 'Query', dimensions: Array<{ __typename: 'Dimension', documentId: string, name: string, slug: string, localizations: Array<{ __typename?: 'Dimension', locale?: string | null, name: string } | null>, dimension_items: Array<{ __typename?: 'DimensionItem', documentId: string, name: string, slug: string, localizations: Array<{ __typename?: 'DimensionItem', locale?: string | null, name: string } | null> } | null> } | null> };

export type DimensionTableStrapi_DimensionFragment = { __typename: 'Dimension', documentId: string, name: string, slug: string, localizations: Array<{ __typename?: 'Dimension', locale?: string | null, name: string } | null>, dimension_items: Array<{ __typename?: 'DimensionItem', documentId: string, name: string, slug: string, localizations: Array<{ __typename?: 'DimensionItem', locale?: string | null, name: string } | null> } | null> };

export type DimensionTableStrapi_DimensionItemFragment = { __typename?: 'DimensionItem', documentId: string, name: string, slug: string, localizations: Array<{ __typename?: 'DimensionItem', locale?: string | null, name: string } | null> };

export type DimensionBySlugStrapiQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
  slug: Scalars['String']['input'];
}>;


export type DimensionBySlugStrapiQuery = { __typename?: 'Query', dimensions: Array<{ __typename: 'Dimension', documentId: string, name: string, slug: string, localizations: Array<{ __typename?: 'Dimension', locale?: string | null, name: string } | null>, dimension_items: Array<{ __typename?: 'DimensionItem', documentId: string, name: string, slug: string, localizations: Array<{ __typename?: 'DimensionItem', locale?: string | null, name: string } | null> } | null> } | null> };

export type DisclosureRequirementBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type DisclosureRequirementBySlugQuery = { __typename?: 'Query', disclosureRequirements: Array<{ __typename?: 'DisclosureRequirement', documentId: string, slug?: string | null, code?: string | null, content?: { __typename?: 'ComponentDrDrContent', dr_level_2?: Array<{ __typename?: 'ComponentDrDrContentLevel2', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, dr_level_3?: Array<{ __typename?: 'ComponentDrDrContentLevel3', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null } | null, application_requirements?: Array<{ __typename?: 'ComponentArApplicationRequirement', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, sub_chapter?: Array<{ __typename?: 'ComponentArApplicationRequirementSubChapter', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null, minimum_disclosure_requirements: Array<{ __typename?: 'Mdr', content?: { __typename?: 'ComponentMdrMdrLevel1', mdr_level_2?: Array<{ __typename?: 'ComponentMdrMdrLevel2', content?: any | null, mdr_level_3?: Array<{ __typename?: 'ComponentMdrMdrLevel3', content?: any | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, application_requirements?: Array<{ __typename?: 'ComponentArApplicationRequirement', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, sub_chapter?: Array<{ __typename?: 'ComponentArApplicationRequirementSubChapter', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null } | null>, guidances?: Array<{ __typename?: 'ComponentGuidanceGuidance', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null } | null> };

export type DisclosureRequirementFragment = { __typename?: 'DisclosureRequirement', documentId: string, slug?: string | null, code?: string | null, content?: { __typename?: 'ComponentDrDrContent', dr_level_2?: Array<{ __typename?: 'ComponentDrDrContentLevel2', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, dr_level_3?: Array<{ __typename?: 'ComponentDrDrContentLevel3', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null } | null, application_requirements?: Array<{ __typename?: 'ComponentArApplicationRequirement', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, sub_chapter?: Array<{ __typename?: 'ComponentArApplicationRequirementSubChapter', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null, minimum_disclosure_requirements: Array<{ __typename?: 'Mdr', content?: { __typename?: 'ComponentMdrMdrLevel1', mdr_level_2?: Array<{ __typename?: 'ComponentMdrMdrLevel2', content?: any | null, mdr_level_3?: Array<{ __typename?: 'ComponentMdrMdrLevel3', content?: any | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, application_requirements?: Array<{ __typename?: 'ComponentArApplicationRequirement', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, sub_chapter?: Array<{ __typename?: 'ComponentArApplicationRequirementSubChapter', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null } | null>, guidances?: Array<{ __typename?: 'ComponentGuidanceGuidance', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null };

export type DisclosureRequirement_DrLevel1Fragment = { __typename?: 'ComponentDrDrContent', dr_level_2?: Array<{ __typename?: 'ComponentDrDrContentLevel2', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, dr_level_3?: Array<{ __typename?: 'ComponentDrDrContentLevel3', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null };

export type DisclosureRequirement_DrLevel2Fragment = { __typename?: 'ComponentDrDrContentLevel2', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, dr_level_3?: Array<{ __typename?: 'ComponentDrDrContentLevel3', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null };

export type DisclosureRequirement_DrLevel3Fragment = { __typename?: 'ComponentDrDrContentLevel3', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> };

export type DisclosureRequirement_ArFragment = { __typename?: 'ComponentArApplicationRequirement', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, sub_chapter?: Array<{ __typename?: 'ComponentArApplicationRequirementSubChapter', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null };

export type DisclosureRequirement_ArSubChapterFragment = { __typename?: 'ComponentArApplicationRequirementSubChapter', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> };

export type DisclosureRequirement_MdrFragment = { __typename?: 'Mdr', content?: { __typename?: 'ComponentMdrMdrLevel1', mdr_level_2?: Array<{ __typename?: 'ComponentMdrMdrLevel2', content?: any | null, mdr_level_3?: Array<{ __typename?: 'ComponentMdrMdrLevel3', content?: any | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, application_requirements?: Array<{ __typename?: 'ComponentArApplicationRequirement', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, sub_chapter?: Array<{ __typename?: 'ComponentArApplicationRequirementSubChapter', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null };

export type DisclosureRequirement_MdrLevel1Fragment = { __typename?: 'ComponentMdrMdrLevel1', mdr_level_2?: Array<{ __typename?: 'ComponentMdrMdrLevel2', content?: any | null, mdr_level_3?: Array<{ __typename?: 'ComponentMdrMdrLevel3', content?: any | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, application_requirements?: Array<{ __typename?: 'ComponentArApplicationRequirement', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null>, sub_chapter?: Array<{ __typename?: 'ComponentArApplicationRequirementSubChapter', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null, footnotes?: Array<{ __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> };

export type DisclosureRequirement_MdrLevel2Fragment = { __typename?: 'ComponentMdrMdrLevel2', content?: any | null, mdr_level_3?: Array<{ __typename?: 'ComponentMdrMdrLevel3', content?: any | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> } | null> | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> };

export type DisclosureRequirement_MdrLevel3Fragment = { __typename?: 'ComponentMdrMdrLevel3', content?: any | null, datapoints: Array<{ __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null> };

export type DatapointTag_DatapointFragment = { __typename?: 'Datapoint', documentId: string, identifier?: string | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, voluntary?: boolean | null, slug?: string | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null };

export type CmsComponentFootnotes_FootnoteFragment = { __typename?: 'ComponentCommonFootnote', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null };

export type CmsComponentGuidance_GuidanceFragment = { __typename?: 'ComponentGuidanceGuidance', translation?: Array<{ __typename?: 'ComponentI18NRichTranslation', language: Enum_Componenti18Nrichtranslation_Language, content?: any | null } | null> | null };

export type AddEnterpriseIndicator_GetUnitsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type AddEnterpriseIndicator_GetUnitsQuery = { __typename?: 'Query', units: Array<{ __typename?: 'Unit', identifier: string, symbol?: string | null, name: string, unit_type?: { __typename?: 'UnitType', translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null } | null> };

export type AddEnterpriseIndicator_UnitFragment = { __typename?: 'Unit', identifier: string, symbol?: string | null, name: string, unit_type?: { __typename?: 'UnitType', translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null } | null };

export type DimensionDropdownStrapiQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type DimensionDropdownStrapiQuery = { __typename?: 'Query', dimensions: Array<{ __typename?: 'Dimension', documentId: string, name: string, slug: string } | null> };

export type ReportIndicatorCollectImportDataPointsQueryVariables = Exact<{
  slugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReportIndicatorCollectImportDataPointsQuery = { __typename?: 'Query', datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> };

export type IroEvaluation_TopicsQueryVariables = Exact<{
  documentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type IroEvaluation_TopicsQuery = { __typename?: 'Query', topics: Array<{ __typename?: 'Topic', slug: string, description?: any | null, name: string, standard?: { __typename?: 'Standard', name?: string | null } | null } | null> };

export type IroSummary_TopicsQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
  topicIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type IroSummary_TopicsQuery = { __typename?: 'Query', topics: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null> };

export type MaterialityThresholds_TopicsQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
  standardSlugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MaterialityThresholds_TopicsQuery = { __typename?: 'Query', topics: Array<{ __typename?: 'Topic', documentId: string, disclosure_requirements: Array<{ __typename?: 'DisclosureRequirement', documentId: string, code?: string | null, slug?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null, datapoints?: Array<{ __typename?: 'ComponentDrIndicatorDrivenDatapoints', id: string, condition?: { __typename?: 'ComponentDrConditionalDatapoints', indicator?: { __typename?: 'Indicator', documentId: string, slug: string, splitByOrganizationUnit?: boolean | null, dimensions: Array<{ __typename?: 'Dimension', documentId: string, slug: string } | null>, unit_type?: { __typename?: 'UnitType', identifier: string } | null, unit?: { __typename?: 'Unit', identifier: string } | null } | null, yes?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null, no?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null, unconditionals: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null>, children: Array<{ __typename?: 'Topic', documentId: string, children: Array<{ __typename?: 'Topic', documentId: string } | null> } | null> } | null> };

export type MaterialityThresholds_Topic_TreeFragment = { __typename?: 'Topic', documentId: string, disclosure_requirements: Array<{ __typename?: 'DisclosureRequirement', documentId: string, code?: string | null, slug?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null, datapoints?: Array<{ __typename?: 'ComponentDrIndicatorDrivenDatapoints', id: string, condition?: { __typename?: 'ComponentDrConditionalDatapoints', indicator?: { __typename?: 'Indicator', documentId: string, slug: string, splitByOrganizationUnit?: boolean | null, dimensions: Array<{ __typename?: 'Dimension', documentId: string, slug: string } | null>, unit_type?: { __typename?: 'UnitType', identifier: string } | null, unit?: { __typename?: 'Unit', identifier: string } | null } | null, yes?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null, no?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null, unconditionals: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null>, children: Array<{ __typename?: 'Topic', documentId: string, children: Array<{ __typename?: 'Topic', documentId: string } | null> } | null> };

export type MaterialityThresholds_Topic_Level1Fragment = { __typename?: 'Topic', documentId: string };

export type MaterialityThresholds_Topic_Level2Fragment = { __typename?: 'Topic', documentId: string };

export type MaterialityThresholds_Topic_Level3Fragment = { __typename?: 'Topic', documentId: string };

export type DisclosureRequirementList_StandardRequirementsQueryVariables = Exact<{
  standardSlug: Scalars['String']['input'];
}>;


export type DisclosureRequirementList_StandardRequirementsQuery = { __typename?: 'Query', standardRequirements: Array<{ __typename?: 'StandardRequirement', slug: string, position: number, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null, disclosure_requirements: Array<{ __typename?: 'DisclosureRequirement', documentId: string, code?: string | null, slug?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null, datapoints?: Array<{ __typename?: 'ComponentDrIndicatorDrivenDatapoints', id: string, condition?: { __typename?: 'ComponentDrConditionalDatapoints', indicator?: { __typename?: 'Indicator', documentId: string, slug: string, splitByOrganizationUnit?: boolean | null, dimensions: Array<{ __typename?: 'Dimension', documentId: string, slug: string } | null>, unit_type?: { __typename?: 'UnitType', identifier: string } | null, unit?: { __typename?: 'Unit', identifier: string } | null } | null, yes?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null, no?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null, unconditionals: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null> } | null> };

export type DisclosureRequirementList_StandardRequirementFragment = { __typename?: 'StandardRequirement', slug: string, position: number, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null, disclosure_requirements: Array<{ __typename?: 'DisclosureRequirement', documentId: string, code?: string | null, slug?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null, datapoints?: Array<{ __typename?: 'ComponentDrIndicatorDrivenDatapoints', id: string, condition?: { __typename?: 'ComponentDrConditionalDatapoints', indicator?: { __typename?: 'Indicator', documentId: string, slug: string, splitByOrganizationUnit?: boolean | null, dimensions: Array<{ __typename?: 'Dimension', documentId: string, slug: string } | null>, unit_type?: { __typename?: 'UnitType', identifier: string } | null, unit?: { __typename?: 'Unit', identifier: string } | null } | null, yes?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null, no?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null, unconditionals: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null> };

export type DisclosureRequirementList_DisclosureRequirementFragment = { __typename?: 'DisclosureRequirement', documentId: string, code?: string | null, slug?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null, datapoints?: Array<{ __typename?: 'ComponentDrIndicatorDrivenDatapoints', id: string, condition?: { __typename?: 'ComponentDrConditionalDatapoints', indicator?: { __typename?: 'Indicator', documentId: string, slug: string, splitByOrganizationUnit?: boolean | null, dimensions: Array<{ __typename?: 'Dimension', documentId: string, slug: string } | null>, unit_type?: { __typename?: 'UnitType', identifier: string } | null, unit?: { __typename?: 'Unit', identifier: string } | null } | null, yes?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null, no?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null, unconditionals: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null };

export type DisclosureRequirementList_ComponentDrDatapointsFragment = { __typename?: 'ComponentDrIndicatorDrivenDatapoints', id: string, condition?: { __typename?: 'ComponentDrConditionalDatapoints', indicator?: { __typename?: 'Indicator', documentId: string, slug: string, splitByOrganizationUnit?: boolean | null, dimensions: Array<{ __typename?: 'Dimension', documentId: string, slug: string } | null>, unit_type?: { __typename?: 'UnitType', identifier: string } | null, unit?: { __typename?: 'Unit', identifier: string } | null } | null, yes?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null, no?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null, unconditionals: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> };

export type DisclosureRequirementList_DisclosureRequirement_DatapointFragment = { __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null };

export type DisclosureRequirementList_ComponentDrDatapointGroupFragment = { __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> };

export type DisclosureRequirementList_ComponentDrDatapointFragment = { __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null };

export type ReportSynthesis_RequirementsQueryVariables = Exact<{
  slugs: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type ReportSynthesis_RequirementsQuery = { __typename?: 'Query', disclosureRequirements: Array<{ __typename?: 'DisclosureRequirement', documentId: string, code?: string | null, slug?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', language: Enum_Componenti18Ntranslation_Language, name?: string | null } | null> | null, datapoints?: Array<{ __typename?: 'ComponentDrIndicatorDrivenDatapoints', id: string, condition?: { __typename?: 'ComponentDrConditionalDatapoints', indicator?: { __typename?: 'Indicator', documentId: string, slug: string, splitByOrganizationUnit?: boolean | null, dimensions: Array<{ __typename?: 'Dimension', documentId: string, slug: string } | null>, unit_type?: { __typename?: 'UnitType', identifier: string } | null, unit?: { __typename?: 'Unit', identifier: string } | null } | null, yes?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null, no?: Array<{ __typename?: 'ComponentDrDatapointGroup', id: string, dimension?: { __typename?: 'Dimension', slug: string } | null, datapoints: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null, unconditionals: Array<{ __typename?: 'Datapoint', slug?: string | null, voluntary?: boolean | null, paragraph?: string | null, alternative?: boolean | null, conditional?: boolean | null, phasein_all?: string | null, phasein_less750?: string | null, translation?: Array<{ __typename?: 'ComponentI18NTranslation', name?: string | null, language: Enum_Componenti18Ntranslation_Language } | null> | null } | null> } | null> | null } | null> };

export type Referential_TopicsQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
  topicIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type Referential_TopicsQuery = { __typename?: 'Query', topics: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null> } | null> };

export type Referential_TopicFragment = { __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null> };

export type StakeStandardTopicsPickerModal_TopicsQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
  standardSlug: Scalars['String']['input'];
}>;


export type StakeStandardTopicsPickerModal_TopicsQuery = { __typename?: 'Query', topics: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null> };

export type StakeStandardTopicsPickerModal_TopicFragment = { __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null };

export type StakeStandardTopicsPickerModal_Topic_Level1Fragment = { __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null };

export type StakeStandardTopicsPickerModal_Topic_Level2Fragment = { __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null };

export type StakeStandardTopicsPickerModal_Topic_Level3Fragment = { __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null };

export type StakeStandardTopicsPickerModal_Topic_Level4Fragment = { __typename?: 'Topic', documentId: string, name: string, children: Array<{ __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null } | null>, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null };

export type StandardPicker_StandardsQueryVariables = Exact<{ [key: string]: never; }>;


export type StandardPicker_StandardsQuery = { __typename?: 'Query', standards: Array<{ __typename?: 'Standard', documentId: string, name?: string | null, slug: string, isPrivate?: boolean | null } | null> };

export type StandardPicker_StandardFragment = { __typename?: 'Standard', documentId: string, name?: string | null, slug: string, isPrivate?: boolean | null };

export type StandardTopicTag_TopicFragment = { __typename?: 'Topic', documentId: string, name: string, standard?: { __typename?: 'Standard', slug: string, name?: string | null } | null };

export type ComputedIndicator_GetUnitQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
}>;


export type ComputedIndicator_GetUnitQuery = { __typename?: 'Query', units: Array<{ __typename?: 'Unit', identifier: string, symbol?: string | null, name: string } | null> };

export type ComputedIndicator_UnitFragment = { __typename?: 'Unit', identifier: string, symbol?: string | null, name: string };

export type NumberIndicatorValueForm_GetUnitQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
}>;


export type NumberIndicatorValueForm_GetUnitQuery = { __typename?: 'Query', units: Array<{ __typename?: 'Unit', identifier: string, symbol?: string | null, name: string } | null> };

export type NumberIndicatorValueForm_UnitFragment = { __typename?: 'Unit', identifier: string, symbol?: string | null, name: string };

export type GetStandardBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetStandardBySlugQuery = { __typename?: 'Query', standards: Array<{ __typename?: 'Standard', logo_base64?: string | null } | null> };

export const EnterpriseStandardsEditor_StandardFragmentDoc = gql`
    fragment EnterpriseStandardsEditor_Standard on Standard {
  name
  slug
  isPrivate
  translation {
    id
    description
    language
    name
  }
}
    `;
export const DimensionTableStrapi_DimensionItemFragmentDoc = gql`
    fragment DimensionTableStrapi_DimensionItem on DimensionItem {
  documentId
  name
  slug
  localizations {
    locale
    name
  }
}
    `;
export const DimensionTableStrapi_DimensionFragmentDoc = gql`
    fragment DimensionTableStrapi_Dimension on Dimension {
  documentId
  name
  slug
  __typename
  localizations {
    locale
    name
  }
  dimension_items(pagination: {limit: 1000}) {
    ...DimensionTableStrapi_DimensionItem
  }
}
    ${DimensionTableStrapi_DimensionItemFragmentDoc}`;
export const CmsComponentFootnotes_FootnoteFragmentDoc = gql`
    fragment CmsComponentFootnotes_Footnote on ComponentCommonFootnote {
  translation {
    language
    content
  }
}
    `;
export const DatapointTags_Datapoint_StrapiFragmentDoc = gql`
    fragment DatapointTags_Datapoint_Strapi on Datapoint {
  documentId
  alternative
  conditional
  voluntary
  phasein_all
  phasein_less750
}
    `;
export const DatapointTag_DatapointFragmentDoc = gql`
    fragment DatapointTag_Datapoint on Datapoint {
  documentId
  translation {
    language
    name
  }
  identifier
  paragraph
  alternative
  conditional
  voluntary
  slug
  ...DatapointTags_Datapoint_Strapi
}
    ${DatapointTags_Datapoint_StrapiFragmentDoc}`;
export const DisclosureRequirement_DrLevel3FragmentDoc = gql`
    fragment DisclosureRequirement_DRLevel3 on ComponentDrDrContentLevel3 {
  translation {
    language
    content
  }
  footnotes(pagination: {limit: 1000}) {
    ...CmsComponentFootnotes_Footnote
  }
  datapoints(pagination: {limit: 1000}) {
    ...DatapointTag_Datapoint
  }
}
    ${CmsComponentFootnotes_FootnoteFragmentDoc}
${DatapointTag_DatapointFragmentDoc}`;
export const DisclosureRequirement_DrLevel2FragmentDoc = gql`
    fragment DisclosureRequirement_DRLevel2 on ComponentDrDrContentLevel2 {
  translation {
    language
    content
  }
  footnotes(pagination: {limit: 1000}) {
    ...CmsComponentFootnotes_Footnote
  }
  datapoints(pagination: {limit: 1000}) {
    ...DatapointTag_Datapoint
  }
  dr_level_3(pagination: {limit: 1000}) {
    ...DisclosureRequirement_DRLevel3
  }
}
    ${CmsComponentFootnotes_FootnoteFragmentDoc}
${DatapointTag_DatapointFragmentDoc}
${DisclosureRequirement_DrLevel3FragmentDoc}`;
export const DisclosureRequirement_DrLevel1FragmentDoc = gql`
    fragment DisclosureRequirement_DRLevel1 on ComponentDrDrContent {
  dr_level_2(pagination: {limit: 1000}) {
    ...DisclosureRequirement_DRLevel2
  }
}
    ${DisclosureRequirement_DrLevel2FragmentDoc}`;
export const DisclosureRequirement_ArSubChapterFragmentDoc = gql`
    fragment DisclosureRequirement_ARSubChapter on ComponentArApplicationRequirementSubChapter {
  translation {
    language
    content
  }
  footnotes(pagination: {limit: 1000}) {
    ...CmsComponentFootnotes_Footnote
  }
  datapoints(pagination: {limit: 1000}) {
    ...DatapointTag_Datapoint
  }
}
    ${CmsComponentFootnotes_FootnoteFragmentDoc}
${DatapointTag_DatapointFragmentDoc}`;
export const DisclosureRequirement_ArFragmentDoc = gql`
    fragment DisclosureRequirement_Ar on ComponentArApplicationRequirement {
  translation {
    language
    content
  }
  footnotes(pagination: {limit: 1000}) {
    ...CmsComponentFootnotes_Footnote
  }
  datapoints(pagination: {limit: 1000}) {
    ...DatapointTag_Datapoint
  }
  sub_chapter(pagination: {limit: 1000}) {
    ...DisclosureRequirement_ARSubChapter
  }
}
    ${CmsComponentFootnotes_FootnoteFragmentDoc}
${DatapointTag_DatapointFragmentDoc}
${DisclosureRequirement_ArSubChapterFragmentDoc}`;
export const DisclosureRequirement_MdrLevel3FragmentDoc = gql`
    fragment DisclosureRequirement_MDRLevel3 on ComponentMdrMdrLevel3 {
  content
  datapoints(pagination: {limit: 1000}) {
    ...DatapointTag_Datapoint
  }
}
    ${DatapointTag_DatapointFragmentDoc}`;
export const DisclosureRequirement_MdrLevel2FragmentDoc = gql`
    fragment DisclosureRequirement_MDRLevel2 on ComponentMdrMdrLevel2 {
  content
  mdr_level_3(pagination: {limit: 1000}) {
    ...DisclosureRequirement_MDRLevel3
  }
  datapoints(pagination: {limit: 1000}) {
    ...DatapointTag_Datapoint
  }
}
    ${DisclosureRequirement_MdrLevel3FragmentDoc}
${DatapointTag_DatapointFragmentDoc}`;
export const DisclosureRequirement_MdrLevel1FragmentDoc = gql`
    fragment DisclosureRequirement_MDRLevel1 on ComponentMdrMdrLevel1 {
  mdr_level_2(pagination: {limit: 1000}) {
    ...DisclosureRequirement_MDRLevel2
  }
  application_requirements(pagination: {limit: 1000}) {
    ...DisclosureRequirement_Ar
  }
  datapoints(pagination: {limit: 1000}) {
    ...DatapointTag_Datapoint
  }
}
    ${DisclosureRequirement_MdrLevel2FragmentDoc}
${DisclosureRequirement_ArFragmentDoc}
${DatapointTag_DatapointFragmentDoc}`;
export const DisclosureRequirement_MdrFragmentDoc = gql`
    fragment DisclosureRequirement_MDR on Mdr {
  content {
    ...DisclosureRequirement_MDRLevel1
  }
}
    ${DisclosureRequirement_MdrLevel1FragmentDoc}`;
export const CmsComponentGuidance_GuidanceFragmentDoc = gql`
    fragment CmsComponentGuidance_Guidance on ComponentGuidanceGuidance {
  translation {
    language
    content
  }
}
    `;
export const DisclosureRequirementFragmentDoc = gql`
    fragment DisclosureRequirement on DisclosureRequirement {
  documentId
  slug
  code
  content {
    ...DisclosureRequirement_DRLevel1
  }
  application_requirements(pagination: {limit: 1000}) {
    ...DisclosureRequirement_Ar
  }
  minimum_disclosure_requirements(pagination: {limit: 1000}) {
    ...DisclosureRequirement_MDR
  }
  guidances(pagination: {limit: 1000}) {
    ...CmsComponentGuidance_Guidance
  }
}
    ${DisclosureRequirement_DrLevel1FragmentDoc}
${DisclosureRequirement_ArFragmentDoc}
${DisclosureRequirement_MdrFragmentDoc}
${CmsComponentGuidance_GuidanceFragmentDoc}`;
export const AddEnterpriseIndicator_UnitFragmentDoc = gql`
    fragment AddEnterpriseIndicator_Unit on Unit {
  identifier
  symbol
  name
  unit_type {
    translation {
      language
      name
    }
  }
}
    `;
export const MaterialityThresholds_Topic_Level1FragmentDoc = gql`
    fragment MaterialityThresholds_Topic_Level1 on Topic {
  documentId
}
    `;
export const DisclosureRequirementList_ComponentDrDatapointFragmentDoc = gql`
    fragment DisclosureRequirementList_ComponentDrDatapoint on Datapoint {
  slug
  voluntary
  paragraph
  translation {
    name
    language
  }
  alternative
  conditional
  phasein_all
  phasein_less750
}
    `;
export const DisclosureRequirementList_ComponentDrDatapointGroupFragmentDoc = gql`
    fragment DisclosureRequirementList_ComponentDrDatapointGroup on ComponentDrDatapointGroup {
  id
  dimension {
    slug
  }
  datapoints(pagination: {limit: 1000}) {
    ...DisclosureRequirementList_ComponentDrDatapoint
  }
}
    ${DisclosureRequirementList_ComponentDrDatapointFragmentDoc}`;
export const DisclosureRequirementList_ComponentDrDatapointsFragmentDoc = gql`
    fragment DisclosureRequirementList_ComponentDrDatapoints on ComponentDrIndicatorDrivenDatapoints {
  id
  condition {
    indicator {
      documentId
      slug
      dimensions {
        documentId
        slug
      }
      splitByOrganizationUnit
      unit_type {
        identifier
      }
      unit {
        identifier
      }
    }
    yes {
      ...DisclosureRequirementList_ComponentDrDatapointGroup
    }
    no {
      ...DisclosureRequirementList_ComponentDrDatapointGroup
    }
  }
  unconditionals(pagination: {limit: 1000}) {
    ...DisclosureRequirementList_ComponentDrDatapoint
  }
}
    ${DisclosureRequirementList_ComponentDrDatapointGroupFragmentDoc}
${DisclosureRequirementList_ComponentDrDatapointFragmentDoc}`;
export const DisclosureRequirementList_DisclosureRequirementFragmentDoc = gql`
    fragment DisclosureRequirementList_DisclosureRequirement on DisclosureRequirement {
  documentId
  code
  translation {
    language
    name
  }
  slug
  datapoints {
    ...DisclosureRequirementList_ComponentDrDatapoints
  }
}
    ${DisclosureRequirementList_ComponentDrDatapointsFragmentDoc}`;
export const MaterialityThresholds_Topic_Level2FragmentDoc = gql`
    fragment MaterialityThresholds_Topic_Level2 on Topic {
  documentId
}
    `;
export const MaterialityThresholds_Topic_Level3FragmentDoc = gql`
    fragment MaterialityThresholds_Topic_Level3 on Topic {
  documentId
}
    `;
export const MaterialityThresholds_Topic_TreeFragmentDoc = gql`
    fragment MaterialityThresholds_Topic_Tree on Topic {
  ...MaterialityThresholds_Topic_Level1
  disclosure_requirements {
    ...DisclosureRequirementList_DisclosureRequirement
  }
  children {
    ...MaterialityThresholds_Topic_Level2
    children {
      ...MaterialityThresholds_Topic_Level3
    }
  }
}
    ${MaterialityThresholds_Topic_Level1FragmentDoc}
${DisclosureRequirementList_DisclosureRequirementFragmentDoc}
${MaterialityThresholds_Topic_Level2FragmentDoc}
${MaterialityThresholds_Topic_Level3FragmentDoc}`;
export const DisclosureRequirementList_StandardRequirementFragmentDoc = gql`
    fragment DisclosureRequirementList_StandardRequirement on StandardRequirement {
  slug
  translation {
    name
    language
  }
  position
  disclosure_requirements(pagination: {limit: 1000}) {
    ...DisclosureRequirementList_DisclosureRequirement
  }
}
    ${DisclosureRequirementList_DisclosureRequirementFragmentDoc}`;
export const DisclosureRequirementList_DisclosureRequirement_DatapointFragmentDoc = gql`
    fragment DisclosureRequirementList_DisclosureRequirement_Datapoint on Datapoint {
  slug
  voluntary
  paragraph
  translation {
    name
    language
  }
}
    `;
export const StandardTopicTag_TopicFragmentDoc = gql`
    fragment StandardTopicTag_Topic on Topic {
  documentId
  name
  standard {
    slug
    name
  }
}
    `;
export const StakeStandardTopicsPickerModal_TopicFragmentDoc = gql`
    fragment StakeStandardTopicsPickerModal_Topic on Topic {
  documentId
  ...StandardTopicTag_Topic
}
    ${StandardTopicTag_TopicFragmentDoc}`;
export const StakeStandardTopicsPickerModal_Topic_Level4FragmentDoc = gql`
    fragment StakeStandardTopicsPickerModal_Topic_Level4 on Topic {
  ...StakeStandardTopicsPickerModal_Topic
  children {
    ...StakeStandardTopicsPickerModal_Topic
  }
}
    ${StakeStandardTopicsPickerModal_TopicFragmentDoc}`;
export const StakeStandardTopicsPickerModal_Topic_Level3FragmentDoc = gql`
    fragment StakeStandardTopicsPickerModal_Topic_Level3 on Topic {
  ...StakeStandardTopicsPickerModal_Topic
  children {
    ...StakeStandardTopicsPickerModal_Topic_Level4
  }
}
    ${StakeStandardTopicsPickerModal_TopicFragmentDoc}
${StakeStandardTopicsPickerModal_Topic_Level4FragmentDoc}`;
export const StakeStandardTopicsPickerModal_Topic_Level2FragmentDoc = gql`
    fragment StakeStandardTopicsPickerModal_Topic_Level2 on Topic {
  ...StakeStandardTopicsPickerModal_Topic
  children {
    ...StakeStandardTopicsPickerModal_Topic_Level3
  }
}
    ${StakeStandardTopicsPickerModal_TopicFragmentDoc}
${StakeStandardTopicsPickerModal_Topic_Level3FragmentDoc}`;
export const StakeStandardTopicsPickerModal_Topic_Level1FragmentDoc = gql`
    fragment StakeStandardTopicsPickerModal_Topic_Level1 on Topic {
  ...StakeStandardTopicsPickerModal_Topic
  children {
    ...StakeStandardTopicsPickerModal_Topic_Level2
  }
}
    ${StakeStandardTopicsPickerModal_TopicFragmentDoc}
${StakeStandardTopicsPickerModal_Topic_Level2FragmentDoc}`;
export const Referential_TopicFragmentDoc = gql`
    fragment Referential_Topic on Topic {
  ...StandardTopicTag_Topic
  ...StakeStandardTopicsPickerModal_Topic_Level1
}
    ${StandardTopicTag_TopicFragmentDoc}
${StakeStandardTopicsPickerModal_Topic_Level1FragmentDoc}`;
export const StandardPicker_StandardFragmentDoc = gql`
    fragment StandardPicker_Standard on Standard {
  documentId
  name
  slug
  isPrivate
}
    `;
export const ComputedIndicator_UnitFragmentDoc = gql`
    fragment ComputedIndicator_Unit on Unit {
  identifier
  symbol
  name
}
    `;
export const NumberIndicatorValueForm_UnitFragmentDoc = gql`
    fragment NumberIndicatorValueForm_Unit on Unit {
  identifier
  symbol
  name
}
    `;
export const EnterpriseStandardsEditor_StandardsDocument = gql`
    query EnterpriseStandardsEditor_Standards {
  standards(
    filters: {isPrivate: {eq: true}}
    sort: ["name"]
    pagination: {limit: 1000}
  ) {
    ...EnterpriseStandardsEditor_Standard
  }
}
    ${EnterpriseStandardsEditor_StandardFragmentDoc}`;

/**
 * __useEnterpriseStandardsEditor_StandardsQuery__
 *
 * To run a query within a React component, call `useEnterpriseStandardsEditor_StandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseStandardsEditor_StandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseStandardsEditor_StandardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnterpriseStandardsEditor_StandardsQuery(baseOptions?: Apollo.QueryHookOptions<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>(EnterpriseStandardsEditor_StandardsDocument, options);
      }
export function useEnterpriseStandardsEditor_StandardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>(EnterpriseStandardsEditor_StandardsDocument, options);
        }
// @ts-ignore
export function useEnterpriseStandardsEditor_StandardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>): Apollo.UseSuspenseQueryResult<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>;
export function useEnterpriseStandardsEditor_StandardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>): Apollo.UseSuspenseQueryResult<EnterpriseStandardsEditor_StandardsQuery | undefined, EnterpriseStandardsEditor_StandardsQueryVariables>;
export function useEnterpriseStandardsEditor_StandardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>(EnterpriseStandardsEditor_StandardsDocument, options);
        }
export type EnterpriseStandardsEditor_StandardsQueryHookResult = ReturnType<typeof useEnterpriseStandardsEditor_StandardsQuery>;
export type EnterpriseStandardsEditor_StandardsLazyQueryHookResult = ReturnType<typeof useEnterpriseStandardsEditor_StandardsLazyQuery>;
export type EnterpriseStandardsEditor_StandardsSuspenseQueryHookResult = ReturnType<typeof useEnterpriseStandardsEditor_StandardsSuspenseQuery>;
export type EnterpriseStandardsEditor_StandardsQueryResult = Apollo.QueryResult<EnterpriseStandardsEditor_StandardsQuery, EnterpriseStandardsEditor_StandardsQueryVariables>;
export const DimensionTableStrapiDocument = gql`
    query DimensionTableStrapi($locale: I18NLocaleCode!) {
  dimensions(pagination: {pageSize: 1000}, locale: $locale) {
    ...DimensionTableStrapi_Dimension
  }
}
    ${DimensionTableStrapi_DimensionFragmentDoc}`;

/**
 * __useDimensionTableStrapiQuery__
 *
 * To run a query within a React component, call `useDimensionTableStrapiQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionTableStrapiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionTableStrapiQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useDimensionTableStrapiQuery(baseOptions: Apollo.QueryHookOptions<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables> & ({ variables: DimensionTableStrapiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>(DimensionTableStrapiDocument, options);
      }
export function useDimensionTableStrapiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>(DimensionTableStrapiDocument, options);
        }
// @ts-ignore
export function useDimensionTableStrapiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>): Apollo.UseSuspenseQueryResult<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>;
export function useDimensionTableStrapiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>): Apollo.UseSuspenseQueryResult<DimensionTableStrapiQuery | undefined, DimensionTableStrapiQueryVariables>;
export function useDimensionTableStrapiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>(DimensionTableStrapiDocument, options);
        }
export type DimensionTableStrapiQueryHookResult = ReturnType<typeof useDimensionTableStrapiQuery>;
export type DimensionTableStrapiLazyQueryHookResult = ReturnType<typeof useDimensionTableStrapiLazyQuery>;
export type DimensionTableStrapiSuspenseQueryHookResult = ReturnType<typeof useDimensionTableStrapiSuspenseQuery>;
export type DimensionTableStrapiQueryResult = Apollo.QueryResult<DimensionTableStrapiQuery, DimensionTableStrapiQueryVariables>;
export const DimensionBySlugStrapiDocument = gql`
    query DimensionBySlugStrapi($locale: I18NLocaleCode!, $slug: String!) {
  dimensions(filters: {slug: {eq: $slug}}, locale: $locale) {
    ...DimensionTableStrapi_Dimension
  }
}
    ${DimensionTableStrapi_DimensionFragmentDoc}`;

/**
 * __useDimensionBySlugStrapiQuery__
 *
 * To run a query within a React component, call `useDimensionBySlugStrapiQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionBySlugStrapiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionBySlugStrapiQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useDimensionBySlugStrapiQuery(baseOptions: Apollo.QueryHookOptions<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables> & ({ variables: DimensionBySlugStrapiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>(DimensionBySlugStrapiDocument, options);
      }
export function useDimensionBySlugStrapiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>(DimensionBySlugStrapiDocument, options);
        }
// @ts-ignore
export function useDimensionBySlugStrapiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>): Apollo.UseSuspenseQueryResult<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>;
export function useDimensionBySlugStrapiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>): Apollo.UseSuspenseQueryResult<DimensionBySlugStrapiQuery | undefined, DimensionBySlugStrapiQueryVariables>;
export function useDimensionBySlugStrapiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>(DimensionBySlugStrapiDocument, options);
        }
export type DimensionBySlugStrapiQueryHookResult = ReturnType<typeof useDimensionBySlugStrapiQuery>;
export type DimensionBySlugStrapiLazyQueryHookResult = ReturnType<typeof useDimensionBySlugStrapiLazyQuery>;
export type DimensionBySlugStrapiSuspenseQueryHookResult = ReturnType<typeof useDimensionBySlugStrapiSuspenseQuery>;
export type DimensionBySlugStrapiQueryResult = Apollo.QueryResult<DimensionBySlugStrapiQuery, DimensionBySlugStrapiQueryVariables>;
export const DisclosureRequirementBySlugDocument = gql`
    query DisclosureRequirementBySlug($slug: String!) {
  disclosureRequirements(filters: {slug: {eq: $slug}}, pagination: {limit: 1000}) {
    ...DisclosureRequirement
  }
}
    ${DisclosureRequirementFragmentDoc}`;

/**
 * __useDisclosureRequirementBySlugQuery__
 *
 * To run a query within a React component, call `useDisclosureRequirementBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisclosureRequirementBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisclosureRequirementBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useDisclosureRequirementBySlugQuery(baseOptions: Apollo.QueryHookOptions<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables> & ({ variables: DisclosureRequirementBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>(DisclosureRequirementBySlugDocument, options);
      }
export function useDisclosureRequirementBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>(DisclosureRequirementBySlugDocument, options);
        }
// @ts-ignore
export function useDisclosureRequirementBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>;
export function useDisclosureRequirementBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<DisclosureRequirementBySlugQuery | undefined, DisclosureRequirementBySlugQueryVariables>;
export function useDisclosureRequirementBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>(DisclosureRequirementBySlugDocument, options);
        }
export type DisclosureRequirementBySlugQueryHookResult = ReturnType<typeof useDisclosureRequirementBySlugQuery>;
export type DisclosureRequirementBySlugLazyQueryHookResult = ReturnType<typeof useDisclosureRequirementBySlugLazyQuery>;
export type DisclosureRequirementBySlugSuspenseQueryHookResult = ReturnType<typeof useDisclosureRequirementBySlugSuspenseQuery>;
export type DisclosureRequirementBySlugQueryResult = Apollo.QueryResult<DisclosureRequirementBySlugQuery, DisclosureRequirementBySlugQueryVariables>;
export const AddEnterpriseIndicator_GetUnitsDocument = gql`
    query AddEnterpriseIndicator_GetUnits($locale: String!) {
  units(filters: {locale: {eq: $locale}}, pagination: {limit: -1}) {
    ...AddEnterpriseIndicator_Unit
  }
}
    ${AddEnterpriseIndicator_UnitFragmentDoc}`;

/**
 * __useAddEnterpriseIndicator_GetUnitsQuery__
 *
 * To run a query within a React component, call `useAddEnterpriseIndicator_GetUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddEnterpriseIndicator_GetUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddEnterpriseIndicator_GetUnitsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useAddEnterpriseIndicator_GetUnitsQuery(baseOptions: Apollo.QueryHookOptions<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables> & ({ variables: AddEnterpriseIndicator_GetUnitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>(AddEnterpriseIndicator_GetUnitsDocument, options);
      }
export function useAddEnterpriseIndicator_GetUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>(AddEnterpriseIndicator_GetUnitsDocument, options);
        }
// @ts-ignore
export function useAddEnterpriseIndicator_GetUnitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>;
export function useAddEnterpriseIndicator_GetUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<AddEnterpriseIndicator_GetUnitsQuery | undefined, AddEnterpriseIndicator_GetUnitsQueryVariables>;
export function useAddEnterpriseIndicator_GetUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>(AddEnterpriseIndicator_GetUnitsDocument, options);
        }
export type AddEnterpriseIndicator_GetUnitsQueryHookResult = ReturnType<typeof useAddEnterpriseIndicator_GetUnitsQuery>;
export type AddEnterpriseIndicator_GetUnitsLazyQueryHookResult = ReturnType<typeof useAddEnterpriseIndicator_GetUnitsLazyQuery>;
export type AddEnterpriseIndicator_GetUnitsSuspenseQueryHookResult = ReturnType<typeof useAddEnterpriseIndicator_GetUnitsSuspenseQuery>;
export type AddEnterpriseIndicator_GetUnitsQueryResult = Apollo.QueryResult<AddEnterpriseIndicator_GetUnitsQuery, AddEnterpriseIndicator_GetUnitsQueryVariables>;
export const DimensionDropdownStrapiDocument = gql`
    query DimensionDropdownStrapi($locale: I18NLocaleCode) {
  dimensions(locale: $locale, pagination: {pageSize: 1000}) {
    documentId
    name
    slug
  }
}
    `;

/**
 * __useDimensionDropdownStrapiQuery__
 *
 * To run a query within a React component, call `useDimensionDropdownStrapiQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionDropdownStrapiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionDropdownStrapiQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useDimensionDropdownStrapiQuery(baseOptions?: Apollo.QueryHookOptions<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>(DimensionDropdownStrapiDocument, options);
      }
export function useDimensionDropdownStrapiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>(DimensionDropdownStrapiDocument, options);
        }
// @ts-ignore
export function useDimensionDropdownStrapiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>): Apollo.UseSuspenseQueryResult<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>;
export function useDimensionDropdownStrapiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>): Apollo.UseSuspenseQueryResult<DimensionDropdownStrapiQuery | undefined, DimensionDropdownStrapiQueryVariables>;
export function useDimensionDropdownStrapiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>(DimensionDropdownStrapiDocument, options);
        }
export type DimensionDropdownStrapiQueryHookResult = ReturnType<typeof useDimensionDropdownStrapiQuery>;
export type DimensionDropdownStrapiLazyQueryHookResult = ReturnType<typeof useDimensionDropdownStrapiLazyQuery>;
export type DimensionDropdownStrapiSuspenseQueryHookResult = ReturnType<typeof useDimensionDropdownStrapiSuspenseQuery>;
export type DimensionDropdownStrapiQueryResult = Apollo.QueryResult<DimensionDropdownStrapiQuery, DimensionDropdownStrapiQueryVariables>;
export const ReportIndicatorCollectImportDataPointsDocument = gql`
    query ReportIndicatorCollectImportDataPoints($slugs: [String!]!) {
  datapoints(filters: {slug: {in: $slugs}}) {
    slug
    translation {
      name
      language
    }
  }
}
    `;

/**
 * __useReportIndicatorCollectImportDataPointsQuery__
 *
 * To run a query within a React component, call `useReportIndicatorCollectImportDataPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportIndicatorCollectImportDataPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportIndicatorCollectImportDataPointsQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useReportIndicatorCollectImportDataPointsQuery(baseOptions: Apollo.QueryHookOptions<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables> & ({ variables: ReportIndicatorCollectImportDataPointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>(ReportIndicatorCollectImportDataPointsDocument, options);
      }
export function useReportIndicatorCollectImportDataPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>(ReportIndicatorCollectImportDataPointsDocument, options);
        }
// @ts-ignore
export function useReportIndicatorCollectImportDataPointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>;
export function useReportIndicatorCollectImportDataPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportIndicatorCollectImportDataPointsQuery | undefined, ReportIndicatorCollectImportDataPointsQueryVariables>;
export function useReportIndicatorCollectImportDataPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>(ReportIndicatorCollectImportDataPointsDocument, options);
        }
export type ReportIndicatorCollectImportDataPointsQueryHookResult = ReturnType<typeof useReportIndicatorCollectImportDataPointsQuery>;
export type ReportIndicatorCollectImportDataPointsLazyQueryHookResult = ReturnType<typeof useReportIndicatorCollectImportDataPointsLazyQuery>;
export type ReportIndicatorCollectImportDataPointsSuspenseQueryHookResult = ReturnType<typeof useReportIndicatorCollectImportDataPointsSuspenseQuery>;
export type ReportIndicatorCollectImportDataPointsQueryResult = Apollo.QueryResult<ReportIndicatorCollectImportDataPointsQuery, ReportIndicatorCollectImportDataPointsQueryVariables>;
export const IroEvaluation_TopicsDocument = gql`
    query IroEvaluation_Topics($documentIds: [ID!]) {
  topics(filters: {documentId: {in: $documentIds}}) {
    slug
    description
    name
    standard {
      name
    }
  }
}
    `;

/**
 * __useIroEvaluation_TopicsQuery__
 *
 * To run a query within a React component, call `useIroEvaluation_TopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIroEvaluation_TopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIroEvaluation_TopicsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useIroEvaluation_TopicsQuery(baseOptions?: Apollo.QueryHookOptions<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>(IroEvaluation_TopicsDocument, options);
      }
export function useIroEvaluation_TopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>(IroEvaluation_TopicsDocument, options);
        }
// @ts-ignore
export function useIroEvaluation_TopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>;
export function useIroEvaluation_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<IroEvaluation_TopicsQuery | undefined, IroEvaluation_TopicsQueryVariables>;
export function useIroEvaluation_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>(IroEvaluation_TopicsDocument, options);
        }
export type IroEvaluation_TopicsQueryHookResult = ReturnType<typeof useIroEvaluation_TopicsQuery>;
export type IroEvaluation_TopicsLazyQueryHookResult = ReturnType<typeof useIroEvaluation_TopicsLazyQuery>;
export type IroEvaluation_TopicsSuspenseQueryHookResult = ReturnType<typeof useIroEvaluation_TopicsSuspenseQuery>;
export type IroEvaluation_TopicsQueryResult = Apollo.QueryResult<IroEvaluation_TopicsQuery, IroEvaluation_TopicsQueryVariables>;
export const IroSummary_TopicsDocument = gql`
    query IroSummary_Topics($locale: I18NLocaleCode!, $topicIds: [ID]!) {
  topics(
    sort: ["name"]
    locale: $locale
    filters: {documentId: {in: $topicIds}}
    pagination: {limit: 1000}
  ) {
    ...StandardTopicTag_Topic
  }
}
    ${StandardTopicTag_TopicFragmentDoc}`;

/**
 * __useIroSummary_TopicsQuery__
 *
 * To run a query within a React component, call `useIroSummary_TopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIroSummary_TopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIroSummary_TopicsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      topicIds: // value for 'topicIds'
 *   },
 * });
 */
export function useIroSummary_TopicsQuery(baseOptions: Apollo.QueryHookOptions<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables> & ({ variables: IroSummary_TopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>(IroSummary_TopicsDocument, options);
      }
export function useIroSummary_TopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>(IroSummary_TopicsDocument, options);
        }
// @ts-ignore
export function useIroSummary_TopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>;
export function useIroSummary_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<IroSummary_TopicsQuery | undefined, IroSummary_TopicsQueryVariables>;
export function useIroSummary_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>(IroSummary_TopicsDocument, options);
        }
export type IroSummary_TopicsQueryHookResult = ReturnType<typeof useIroSummary_TopicsQuery>;
export type IroSummary_TopicsLazyQueryHookResult = ReturnType<typeof useIroSummary_TopicsLazyQuery>;
export type IroSummary_TopicsSuspenseQueryHookResult = ReturnType<typeof useIroSummary_TopicsSuspenseQuery>;
export type IroSummary_TopicsQueryResult = Apollo.QueryResult<IroSummary_TopicsQuery, IroSummary_TopicsQueryVariables>;
export const MaterialityThresholds_TopicsDocument = gql`
    query MaterialityThresholds_Topics($locale: I18NLocaleCode!, $standardSlugs: [String!]!) {
  topics(
    sort: ["position"]
    locale: $locale
    filters: {parent: {documentId: {eq: null}}, and: {standard: {slug: {in: $standardSlugs}}}}
    pagination: {limit: 1000}
  ) {
    ...MaterialityThresholds_Topic_Tree
  }
}
    ${MaterialityThresholds_Topic_TreeFragmentDoc}`;

/**
 * __useMaterialityThresholds_TopicsQuery__
 *
 * To run a query within a React component, call `useMaterialityThresholds_TopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialityThresholds_TopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialityThresholds_TopicsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      standardSlugs: // value for 'standardSlugs'
 *   },
 * });
 */
export function useMaterialityThresholds_TopicsQuery(baseOptions: Apollo.QueryHookOptions<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables> & ({ variables: MaterialityThresholds_TopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>(MaterialityThresholds_TopicsDocument, options);
      }
export function useMaterialityThresholds_TopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>(MaterialityThresholds_TopicsDocument, options);
        }
// @ts-ignore
export function useMaterialityThresholds_TopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>;
export function useMaterialityThresholds_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<MaterialityThresholds_TopicsQuery | undefined, MaterialityThresholds_TopicsQueryVariables>;
export function useMaterialityThresholds_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>(MaterialityThresholds_TopicsDocument, options);
        }
export type MaterialityThresholds_TopicsQueryHookResult = ReturnType<typeof useMaterialityThresholds_TopicsQuery>;
export type MaterialityThresholds_TopicsLazyQueryHookResult = ReturnType<typeof useMaterialityThresholds_TopicsLazyQuery>;
export type MaterialityThresholds_TopicsSuspenseQueryHookResult = ReturnType<typeof useMaterialityThresholds_TopicsSuspenseQuery>;
export type MaterialityThresholds_TopicsQueryResult = Apollo.QueryResult<MaterialityThresholds_TopicsQuery, MaterialityThresholds_TopicsQueryVariables>;
export const DisclosureRequirementList_StandardRequirementsDocument = gql`
    query DisclosureRequirementList_StandardRequirements($standardSlug: String!) {
  standardRequirements(
    sort: ["position"]
    filters: {standard: {slug: {eq: $standardSlug}}}
    pagination: {limit: 1000}
  ) {
    ...DisclosureRequirementList_StandardRequirement
  }
}
    ${DisclosureRequirementList_StandardRequirementFragmentDoc}`;

/**
 * __useDisclosureRequirementList_StandardRequirementsQuery__
 *
 * To run a query within a React component, call `useDisclosureRequirementList_StandardRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisclosureRequirementList_StandardRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisclosureRequirementList_StandardRequirementsQuery({
 *   variables: {
 *      standardSlug: // value for 'standardSlug'
 *   },
 * });
 */
export function useDisclosureRequirementList_StandardRequirementsQuery(baseOptions: Apollo.QueryHookOptions<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables> & ({ variables: DisclosureRequirementList_StandardRequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>(DisclosureRequirementList_StandardRequirementsDocument, options);
      }
export function useDisclosureRequirementList_StandardRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>(DisclosureRequirementList_StandardRequirementsDocument, options);
        }
// @ts-ignore
export function useDisclosureRequirementList_StandardRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>;
export function useDisclosureRequirementList_StandardRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<DisclosureRequirementList_StandardRequirementsQuery | undefined, DisclosureRequirementList_StandardRequirementsQueryVariables>;
export function useDisclosureRequirementList_StandardRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>(DisclosureRequirementList_StandardRequirementsDocument, options);
        }
export type DisclosureRequirementList_StandardRequirementsQueryHookResult = ReturnType<typeof useDisclosureRequirementList_StandardRequirementsQuery>;
export type DisclosureRequirementList_StandardRequirementsLazyQueryHookResult = ReturnType<typeof useDisclosureRequirementList_StandardRequirementsLazyQuery>;
export type DisclosureRequirementList_StandardRequirementsSuspenseQueryHookResult = ReturnType<typeof useDisclosureRequirementList_StandardRequirementsSuspenseQuery>;
export type DisclosureRequirementList_StandardRequirementsQueryResult = Apollo.QueryResult<DisclosureRequirementList_StandardRequirementsQuery, DisclosureRequirementList_StandardRequirementsQueryVariables>;
export const ReportSynthesis_RequirementsDocument = gql`
    query ReportSynthesis_Requirements($slugs: [String]!) {
  disclosureRequirements(filters: {slug: {in: $slugs}}, pagination: {limit: 1000}) {
    documentId
    ...DisclosureRequirementList_DisclosureRequirement
  }
}
    ${DisclosureRequirementList_DisclosureRequirementFragmentDoc}`;

/**
 * __useReportSynthesis_RequirementsQuery__
 *
 * To run a query within a React component, call `useReportSynthesis_RequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSynthesis_RequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSynthesis_RequirementsQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useReportSynthesis_RequirementsQuery(baseOptions: Apollo.QueryHookOptions<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables> & ({ variables: ReportSynthesis_RequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>(ReportSynthesis_RequirementsDocument, options);
      }
export function useReportSynthesis_RequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>(ReportSynthesis_RequirementsDocument, options);
        }
// @ts-ignore
export function useReportSynthesis_RequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>;
export function useReportSynthesis_RequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportSynthesis_RequirementsQuery | undefined, ReportSynthesis_RequirementsQueryVariables>;
export function useReportSynthesis_RequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>(ReportSynthesis_RequirementsDocument, options);
        }
export type ReportSynthesis_RequirementsQueryHookResult = ReturnType<typeof useReportSynthesis_RequirementsQuery>;
export type ReportSynthesis_RequirementsLazyQueryHookResult = ReturnType<typeof useReportSynthesis_RequirementsLazyQuery>;
export type ReportSynthesis_RequirementsSuspenseQueryHookResult = ReturnType<typeof useReportSynthesis_RequirementsSuspenseQuery>;
export type ReportSynthesis_RequirementsQueryResult = Apollo.QueryResult<ReportSynthesis_RequirementsQuery, ReportSynthesis_RequirementsQueryVariables>;
export const Referential_TopicsDocument = gql`
    query Referential_Topics($locale: I18NLocaleCode!, $topicIds: [ID]!) {
  topics(
    sort: ["name"]
    locale: $locale
    filters: {documentId: {in: $topicIds}}
    pagination: {limit: 1000}
  ) {
    ...Referential_Topic
  }
}
    ${Referential_TopicFragmentDoc}`;

/**
 * __useReferential_TopicsQuery__
 *
 * To run a query within a React component, call `useReferential_TopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferential_TopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferential_TopicsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      topicIds: // value for 'topicIds'
 *   },
 * });
 */
export function useReferential_TopicsQuery(baseOptions: Apollo.QueryHookOptions<Referential_TopicsQuery, Referential_TopicsQueryVariables> & ({ variables: Referential_TopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Referential_TopicsQuery, Referential_TopicsQueryVariables>(Referential_TopicsDocument, options);
      }
export function useReferential_TopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Referential_TopicsQuery, Referential_TopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Referential_TopicsQuery, Referential_TopicsQueryVariables>(Referential_TopicsDocument, options);
        }
// @ts-ignore
export function useReferential_TopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Referential_TopicsQuery, Referential_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<Referential_TopicsQuery, Referential_TopicsQueryVariables>;
export function useReferential_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Referential_TopicsQuery, Referential_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<Referential_TopicsQuery | undefined, Referential_TopicsQueryVariables>;
export function useReferential_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Referential_TopicsQuery, Referential_TopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Referential_TopicsQuery, Referential_TopicsQueryVariables>(Referential_TopicsDocument, options);
        }
export type Referential_TopicsQueryHookResult = ReturnType<typeof useReferential_TopicsQuery>;
export type Referential_TopicsLazyQueryHookResult = ReturnType<typeof useReferential_TopicsLazyQuery>;
export type Referential_TopicsSuspenseQueryHookResult = ReturnType<typeof useReferential_TopicsSuspenseQuery>;
export type Referential_TopicsQueryResult = Apollo.QueryResult<Referential_TopicsQuery, Referential_TopicsQueryVariables>;
export const StakeStandardTopicsPickerModal_TopicsDocument = gql`
    query StakeStandardTopicsPickerModal_Topics($locale: I18NLocaleCode!, $standardSlug: String!) {
  topics(
    sort: ["position"]
    locale: $locale
    filters: {parent: {documentId: {eq: null}}, and: {standard: {slug: {eq: $standardSlug}}}}
    pagination: {limit: 1000}
  ) {
    ...StakeStandardTopicsPickerModal_Topic_Level1
  }
}
    ${StakeStandardTopicsPickerModal_Topic_Level1FragmentDoc}`;

/**
 * __useStakeStandardTopicsPickerModal_TopicsQuery__
 *
 * To run a query within a React component, call `useStakeStandardTopicsPickerModal_TopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStakeStandardTopicsPickerModal_TopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStakeStandardTopicsPickerModal_TopicsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      standardSlug: // value for 'standardSlug'
 *   },
 * });
 */
export function useStakeStandardTopicsPickerModal_TopicsQuery(baseOptions: Apollo.QueryHookOptions<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables> & ({ variables: StakeStandardTopicsPickerModal_TopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>(StakeStandardTopicsPickerModal_TopicsDocument, options);
      }
export function useStakeStandardTopicsPickerModal_TopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>(StakeStandardTopicsPickerModal_TopicsDocument, options);
        }
// @ts-ignore
export function useStakeStandardTopicsPickerModal_TopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>;
export function useStakeStandardTopicsPickerModal_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<StakeStandardTopicsPickerModal_TopicsQuery | undefined, StakeStandardTopicsPickerModal_TopicsQueryVariables>;
export function useStakeStandardTopicsPickerModal_TopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>(StakeStandardTopicsPickerModal_TopicsDocument, options);
        }
export type StakeStandardTopicsPickerModal_TopicsQueryHookResult = ReturnType<typeof useStakeStandardTopicsPickerModal_TopicsQuery>;
export type StakeStandardTopicsPickerModal_TopicsLazyQueryHookResult = ReturnType<typeof useStakeStandardTopicsPickerModal_TopicsLazyQuery>;
export type StakeStandardTopicsPickerModal_TopicsSuspenseQueryHookResult = ReturnType<typeof useStakeStandardTopicsPickerModal_TopicsSuspenseQuery>;
export type StakeStandardTopicsPickerModal_TopicsQueryResult = Apollo.QueryResult<StakeStandardTopicsPickerModal_TopicsQuery, StakeStandardTopicsPickerModal_TopicsQueryVariables>;
export const StandardPicker_StandardsDocument = gql`
    query StandardPicker_Standards {
  standards(sort: ["name"], pagination: {limit: 1000}) {
    ...StandardPicker_Standard
  }
}
    ${StandardPicker_StandardFragmentDoc}`;

/**
 * __useStandardPicker_StandardsQuery__
 *
 * To run a query within a React component, call `useStandardPicker_StandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardPicker_StandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardPicker_StandardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStandardPicker_StandardsQuery(baseOptions?: Apollo.QueryHookOptions<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>(StandardPicker_StandardsDocument, options);
      }
export function useStandardPicker_StandardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>(StandardPicker_StandardsDocument, options);
        }
// @ts-ignore
export function useStandardPicker_StandardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>): Apollo.UseSuspenseQueryResult<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>;
export function useStandardPicker_StandardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>): Apollo.UseSuspenseQueryResult<StandardPicker_StandardsQuery | undefined, StandardPicker_StandardsQueryVariables>;
export function useStandardPicker_StandardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>(StandardPicker_StandardsDocument, options);
        }
export type StandardPicker_StandardsQueryHookResult = ReturnType<typeof useStandardPicker_StandardsQuery>;
export type StandardPicker_StandardsLazyQueryHookResult = ReturnType<typeof useStandardPicker_StandardsLazyQuery>;
export type StandardPicker_StandardsSuspenseQueryHookResult = ReturnType<typeof useStandardPicker_StandardsSuspenseQuery>;
export type StandardPicker_StandardsQueryResult = Apollo.QueryResult<StandardPicker_StandardsQuery, StandardPicker_StandardsQueryVariables>;
export const ComputedIndicator_GetUnitDocument = gql`
    query ComputedIndicator_GetUnit($locale: String!, $identifier: String!) {
  units(
    filters: {locale: {eq: $locale}, identifier: {eq: $identifier}}
    pagination: {limit: -1}
  ) {
    ...ComputedIndicator_Unit
  }
}
    ${ComputedIndicator_UnitFragmentDoc}`;

/**
 * __useComputedIndicator_GetUnitQuery__
 *
 * To run a query within a React component, call `useComputedIndicator_GetUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputedIndicator_GetUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputedIndicator_GetUnitQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useComputedIndicator_GetUnitQuery(baseOptions: Apollo.QueryHookOptions<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables> & ({ variables: ComputedIndicator_GetUnitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>(ComputedIndicator_GetUnitDocument, options);
      }
export function useComputedIndicator_GetUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>(ComputedIndicator_GetUnitDocument, options);
        }
// @ts-ignore
export function useComputedIndicator_GetUnitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>): Apollo.UseSuspenseQueryResult<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>;
export function useComputedIndicator_GetUnitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>): Apollo.UseSuspenseQueryResult<ComputedIndicator_GetUnitQuery | undefined, ComputedIndicator_GetUnitQueryVariables>;
export function useComputedIndicator_GetUnitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>(ComputedIndicator_GetUnitDocument, options);
        }
export type ComputedIndicator_GetUnitQueryHookResult = ReturnType<typeof useComputedIndicator_GetUnitQuery>;
export type ComputedIndicator_GetUnitLazyQueryHookResult = ReturnType<typeof useComputedIndicator_GetUnitLazyQuery>;
export type ComputedIndicator_GetUnitSuspenseQueryHookResult = ReturnType<typeof useComputedIndicator_GetUnitSuspenseQuery>;
export type ComputedIndicator_GetUnitQueryResult = Apollo.QueryResult<ComputedIndicator_GetUnitQuery, ComputedIndicator_GetUnitQueryVariables>;
export const NumberIndicatorValueForm_GetUnitDocument = gql`
    query NumberIndicatorValueForm_GetUnit($locale: String!, $identifier: String!) {
  units(
    filters: {locale: {eq: $locale}, identifier: {eq: $identifier}}
    pagination: {limit: -1}
  ) {
    ...NumberIndicatorValueForm_Unit
  }
}
    ${NumberIndicatorValueForm_UnitFragmentDoc}`;

/**
 * __useNumberIndicatorValueForm_GetUnitQuery__
 *
 * To run a query within a React component, call `useNumberIndicatorValueForm_GetUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberIndicatorValueForm_GetUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberIndicatorValueForm_GetUnitQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useNumberIndicatorValueForm_GetUnitQuery(baseOptions: Apollo.QueryHookOptions<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables> & ({ variables: NumberIndicatorValueForm_GetUnitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>(NumberIndicatorValueForm_GetUnitDocument, options);
      }
export function useNumberIndicatorValueForm_GetUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>(NumberIndicatorValueForm_GetUnitDocument, options);
        }
// @ts-ignore
export function useNumberIndicatorValueForm_GetUnitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>): Apollo.UseSuspenseQueryResult<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>;
export function useNumberIndicatorValueForm_GetUnitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>): Apollo.UseSuspenseQueryResult<NumberIndicatorValueForm_GetUnitQuery | undefined, NumberIndicatorValueForm_GetUnitQueryVariables>;
export function useNumberIndicatorValueForm_GetUnitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>(NumberIndicatorValueForm_GetUnitDocument, options);
        }
export type NumberIndicatorValueForm_GetUnitQueryHookResult = ReturnType<typeof useNumberIndicatorValueForm_GetUnitQuery>;
export type NumberIndicatorValueForm_GetUnitLazyQueryHookResult = ReturnType<typeof useNumberIndicatorValueForm_GetUnitLazyQuery>;
export type NumberIndicatorValueForm_GetUnitSuspenseQueryHookResult = ReturnType<typeof useNumberIndicatorValueForm_GetUnitSuspenseQuery>;
export type NumberIndicatorValueForm_GetUnitQueryResult = Apollo.QueryResult<NumberIndicatorValueForm_GetUnitQuery, NumberIndicatorValueForm_GetUnitQueryVariables>;
export const GetStandardBySlugDocument = gql`
    query getStandardBySlug($slug: String!) {
  standards(filters: {slug: {eq: $slug}}) {
    logo_base64
  }
}
    `;

/**
 * __useGetStandardBySlugQuery__
 *
 * To run a query within a React component, call `useGetStandardBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetStandardBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetStandardBySlugQuery, GetStandardBySlugQueryVariables> & ({ variables: GetStandardBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>(GetStandardBySlugDocument, options);
      }
export function useGetStandardBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>(GetStandardBySlugDocument, options);
        }
// @ts-ignore
export function useGetStandardBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>;
export function useGetStandardBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetStandardBySlugQuery | undefined, GetStandardBySlugQueryVariables>;
export function useGetStandardBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>(GetStandardBySlugDocument, options);
        }
export type GetStandardBySlugQueryHookResult = ReturnType<typeof useGetStandardBySlugQuery>;
export type GetStandardBySlugLazyQueryHookResult = ReturnType<typeof useGetStandardBySlugLazyQuery>;
export type GetStandardBySlugSuspenseQueryHookResult = ReturnType<typeof useGetStandardBySlugSuspenseQuery>;
export type GetStandardBySlugQueryResult = Apollo.QueryResult<GetStandardBySlugQuery, GetStandardBySlugQueryVariables>;
export type ChoiceKeySpecifier = ('createdAt' | 'documentId' | 'publishedAt' | 'slug' | 'translation' | 'updatedAt' | ChoiceKeySpecifier)[];
export type ChoiceFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChoiceEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | ChoiceEntityResponseCollectionKeySpecifier)[];
export type ChoiceEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChoiceRelationResponseCollectionKeySpecifier = ('nodes' | ChoiceRelationResponseCollectionKeySpecifier)[];
export type ChoiceRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChoicesListKeySpecifier = ('choices' | 'choices_connection' | 'createdAt' | 'documentId' | 'name' | 'publishedAt' | 'slug' | 'updatedAt' | ChoicesListKeySpecifier)[];
export type ChoicesListFieldPolicy = {
	choices?: FieldPolicy<any> | FieldReadFunction<any>,
	choices_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChoicesListEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | ChoicesListEntityResponseCollectionKeySpecifier)[];
export type ChoicesListEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentArApplicationRequirementKeySpecifier = ('datapoints' | 'datapoints_connection' | 'footnotes' | 'id' | 'sub_chapter' | 'translation' | ComponentArApplicationRequirementKeySpecifier)[];
export type ComponentArApplicationRequirementFieldPolicy = {
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	footnotes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sub_chapter?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentArApplicationRequirementSubChapterKeySpecifier = ('datapoints' | 'datapoints_connection' | 'footnotes' | 'id' | 'translation' | ComponentArApplicationRequirementSubChapterKeySpecifier)[];
export type ComponentArApplicationRequirementSubChapterFieldPolicy = {
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	footnotes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentCommonFootnoteKeySpecifier = ('id' | 'translation' | ComponentCommonFootnoteKeySpecifier)[];
export type ComponentCommonFootnoteFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentDrConditionalDatapointsKeySpecifier = ('id' | 'indicator' | 'no' | 'yes' | ComponentDrConditionalDatapointsKeySpecifier)[];
export type ComponentDrConditionalDatapointsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	indicator?: FieldPolicy<any> | FieldReadFunction<any>,
	no?: FieldPolicy<any> | FieldReadFunction<any>,
	yes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentDrDatapointGroupKeySpecifier = ('datapoints' | 'datapoints_connection' | 'dimension' | 'id' | ComponentDrDatapointGroupKeySpecifier)[];
export type ComponentDrDatapointGroupFieldPolicy = {
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	dimension?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentDrDrContentKeySpecifier = ('dr_level_2' | 'id' | ComponentDrDrContentKeySpecifier)[];
export type ComponentDrDrContentFieldPolicy = {
	dr_level_2?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentDrDrContentLevel2KeySpecifier = ('datapoints' | 'datapoints_connection' | 'dr_level_3' | 'footnotes' | 'id' | 'translation' | ComponentDrDrContentLevel2KeySpecifier)[];
export type ComponentDrDrContentLevel2FieldPolicy = {
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_level_3?: FieldPolicy<any> | FieldReadFunction<any>,
	footnotes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentDrDrContentLevel3KeySpecifier = ('datapoints' | 'datapoints_connection' | 'footnotes' | 'id' | 'translation' | ComponentDrDrContentLevel3KeySpecifier)[];
export type ComponentDrDrContentLevel3FieldPolicy = {
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	footnotes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentDrIndicatorDrivenDatapointsKeySpecifier = ('condition' | 'id' | 'unconditionals' | 'unconditionals_connection' | ComponentDrIndicatorDrivenDatapointsKeySpecifier)[];
export type ComponentDrIndicatorDrivenDatapointsFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	unconditionals?: FieldPolicy<any> | FieldReadFunction<any>,
	unconditionals_connection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentGuidanceGuidanceKeySpecifier = ('id' | 'translation' | ComponentGuidanceGuidanceKeySpecifier)[];
export type ComponentGuidanceGuidanceFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentI18NRichTranslationKeySpecifier = ('content' | 'id' | 'language' | ComponentI18NRichTranslationKeySpecifier)[];
export type ComponentI18NRichTranslationFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentI18NTranslationKeySpecifier = ('description' | 'id' | 'language' | 'name' | ComponentI18NTranslationKeySpecifier)[];
export type ComponentI18NTranslationFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentMdrMdrLevel1KeySpecifier = ('application_requirements' | 'datapoints' | 'datapoints_connection' | 'id' | 'mdr_level_2' | ComponentMdrMdrLevel1KeySpecifier)[];
export type ComponentMdrMdrLevel1FieldPolicy = {
	application_requirements?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mdr_level_2?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentMdrMdrLevel2KeySpecifier = ('content' | 'datapoints' | 'datapoints_connection' | 'id' | 'mdr_level_3' | ComponentMdrMdrLevel2KeySpecifier)[];
export type ComponentMdrMdrLevel2FieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	mdr_level_3?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ComponentMdrMdrLevel3KeySpecifier = ('content' | 'datapoints' | 'datapoints_connection' | 'id' | ComponentMdrMdrLevel3KeySpecifier)[];
export type ComponentMdrMdrLevel3FieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DatapointKeySpecifier = ('alternative' | 'ar' | 'conditional' | 'createdAt' | 'defineDimensionItemsOf' | 'documentId' | 'dr' | 'esrs' | 'identifier' | 'indicators' | 'indicators_connection' | 'paragraph' | 'phasein_all' | 'phasein_less750' | 'publishedAt' | 'related_datapoints' | 'related_datapoints_connection' | 'slug' | 'translation' | 'type' | 'updatedAt' | 'voluntary' | DatapointKeySpecifier)[];
export type DatapointFieldPolicy = {
	alternative?: FieldPolicy<any> | FieldReadFunction<any>,
	ar?: FieldPolicy<any> | FieldReadFunction<any>,
	conditional?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	defineDimensionItemsOf?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	dr?: FieldPolicy<any> | FieldReadFunction<any>,
	esrs?: FieldPolicy<any> | FieldReadFunction<any>,
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	indicators?: FieldPolicy<any> | FieldReadFunction<any>,
	indicators_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	paragraph?: FieldPolicy<any> | FieldReadFunction<any>,
	phasein_all?: FieldPolicy<any> | FieldReadFunction<any>,
	phasein_less750?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	related_datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	related_datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	voluntary?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DatapointEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | DatapointEntityResponseCollectionKeySpecifier)[];
export type DatapointEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DatapointRelationResponseCollectionKeySpecifier = ('nodes' | DatapointRelationResponseCollectionKeySpecifier)[];
export type DatapointRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMutationResponseKeySpecifier = ('documentId' | DeleteMutationResponseKeySpecifier)[];
export type DeleteMutationResponseFieldPolicy = {
	documentId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DimensionKeySpecifier = ('createdAt' | 'dimension_items' | 'dimension_items_connection' | 'documentId' | 'locale' | 'localizations' | 'localizations_connection' | 'name' | 'publishedAt' | 'slug' | 'updatedAt' | DimensionKeySpecifier)[];
export type DimensionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dimension_items?: FieldPolicy<any> | FieldReadFunction<any>,
	dimension_items_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DimensionEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | DimensionEntityResponseCollectionKeySpecifier)[];
export type DimensionEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DimensionItemKeySpecifier = ('createdAt' | 'dimension' | 'documentId' | 'locale' | 'localizations' | 'localizations_connection' | 'name' | 'publishedAt' | 'slug' | 'updatedAt' | DimensionItemKeySpecifier)[];
export type DimensionItemFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dimension?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DimensionItemEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | DimensionItemEntityResponseCollectionKeySpecifier)[];
export type DimensionItemEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DimensionItemRelationResponseCollectionKeySpecifier = ('nodes' | DimensionItemRelationResponseCollectionKeySpecifier)[];
export type DimensionItemRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DimensionRelationResponseCollectionKeySpecifier = ('nodes' | DimensionRelationResponseCollectionKeySpecifier)[];
export type DimensionRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureRequirementKeySpecifier = ('application_requirements' | 'code' | 'content' | 'createdAt' | 'datapoints' | 'documentId' | 'esrs' | 'guidances' | 'minimum_disclosure_requirements' | 'minimum_disclosure_requirements_connection' | 'publishedAt' | 'slug' | 'standard_requirement' | 'standard_requirement_connection' | 'translation' | 'updatedAt' | DisclosureRequirementKeySpecifier)[];
export type DisclosureRequirementFieldPolicy = {
	application_requirements?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	esrs?: FieldPolicy<any> | FieldReadFunction<any>,
	guidances?: FieldPolicy<any> | FieldReadFunction<any>,
	minimum_disclosure_requirements?: FieldPolicy<any> | FieldReadFunction<any>,
	minimum_disclosure_requirements_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	standard_requirement?: FieldPolicy<any> | FieldReadFunction<any>,
	standard_requirement_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureRequirementEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | DisclosureRequirementEntityResponseCollectionKeySpecifier)[];
export type DisclosureRequirementEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DisclosureRequirementRelationResponseCollectionKeySpecifier = ('nodes' | DisclosureRequirementRelationResponseCollectionKeySpecifier)[];
export type DisclosureRequirementRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type I18NLocaleKeySpecifier = ('code' | 'createdAt' | 'documentId' | 'name' | 'publishedAt' | 'updatedAt' | I18NLocaleKeySpecifier)[];
export type I18NLocaleFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type I18NLocaleEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | I18NLocaleEntityResponseCollectionKeySpecifier)[];
export type I18NLocaleEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndicatorKeySpecifier = ('choices_list' | 'createdAt' | 'datapoints' | 'datapoints_connection' | 'dimensions' | 'dimensions_connection' | 'documentId' | 'publishedAt' | 'slug' | 'splitByOrganizationUnit' | 'translation' | 'type' | 'unit' | 'unit_type' | 'updatedAt' | IndicatorKeySpecifier)[];
export type IndicatorFieldPolicy = {
	choices_list?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensions?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensions_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	splitByOrganizationUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unit_type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndicatorEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | IndicatorEntityResponseCollectionKeySpecifier)[];
export type IndicatorEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IndicatorRelationResponseCollectionKeySpecifier = ('nodes' | IndicatorRelationResponseCollectionKeySpecifier)[];
export type IndicatorRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MdrKeySpecifier = ('code' | 'content' | 'createdAt' | 'documentId' | 'locale' | 'localizations' | 'localizations_connection' | 'publishedAt' | 'slug' | 'title' | 'updatedAt' | MdrKeySpecifier)[];
export type MdrFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MdrEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | MdrEntityResponseCollectionKeySpecifier)[];
export type MdrEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MdrRelationResponseCollectionKeySpecifier = ('nodes' | MdrRelationResponseCollectionKeySpecifier)[];
export type MdrRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('changePassword' | 'createChoice' | 'createChoicesList' | 'createDatapoint' | 'createDimension' | 'createDimensionItem' | 'createDisclosureRequirement' | 'createIndicator' | 'createMdr' | 'createReviewWorkflowsWorkflow' | 'createReviewWorkflowsWorkflowStage' | 'createStandard' | 'createStandardRequirement' | 'createTopic' | 'createUnit' | 'createUnitType' | 'createUsersPermissionsRole' | 'createUsersPermissionsUser' | 'deleteChoice' | 'deleteChoicesList' | 'deleteDatapoint' | 'deleteDimension' | 'deleteDimensionItem' | 'deleteDisclosureRequirement' | 'deleteIndicator' | 'deleteMdr' | 'deleteReviewWorkflowsWorkflow' | 'deleteReviewWorkflowsWorkflowStage' | 'deleteStandard' | 'deleteStandardRequirement' | 'deleteTopic' | 'deleteUnit' | 'deleteUnitType' | 'deleteUploadFile' | 'deleteUsersPermissionsRole' | 'deleteUsersPermissionsUser' | 'emailConfirmation' | 'forgotPassword' | 'login' | 'register' | 'resetPassword' | 'updateChoice' | 'updateChoicesList' | 'updateDatapoint' | 'updateDimension' | 'updateDimensionItem' | 'updateDisclosureRequirement' | 'updateIndicator' | 'updateMdr' | 'updateReviewWorkflowsWorkflow' | 'updateReviewWorkflowsWorkflowStage' | 'updateStandard' | 'updateStandardRequirement' | 'updateTopic' | 'updateUnit' | 'updateUnitType' | 'updateUploadFile' | 'updateUsersPermissionsRole' | 'updateUsersPermissionsUser' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	changePassword?: FieldPolicy<any> | FieldReadFunction<any>,
	createChoice?: FieldPolicy<any> | FieldReadFunction<any>,
	createChoicesList?: FieldPolicy<any> | FieldReadFunction<any>,
	createDatapoint?: FieldPolicy<any> | FieldReadFunction<any>,
	createDimension?: FieldPolicy<any> | FieldReadFunction<any>,
	createDimensionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	createDisclosureRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	createIndicator?: FieldPolicy<any> | FieldReadFunction<any>,
	createMdr?: FieldPolicy<any> | FieldReadFunction<any>,
	createReviewWorkflowsWorkflow?: FieldPolicy<any> | FieldReadFunction<any>,
	createReviewWorkflowsWorkflowStage?: FieldPolicy<any> | FieldReadFunction<any>,
	createStandard?: FieldPolicy<any> | FieldReadFunction<any>,
	createStandardRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	createTopic?: FieldPolicy<any> | FieldReadFunction<any>,
	createUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	createUnitType?: FieldPolicy<any> | FieldReadFunction<any>,
	createUsersPermissionsRole?: FieldPolicy<any> | FieldReadFunction<any>,
	createUsersPermissionsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteChoice?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteChoicesList?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDatapoint?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDimension?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDimensionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteDisclosureRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteIndicator?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMdr?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteReviewWorkflowsWorkflow?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteReviewWorkflowsWorkflowStage?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStandard?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteStandardRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTopic?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUnitType?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUploadFile?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUsersPermissionsRole?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUsersPermissionsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	emailConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	forgotPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	register?: FieldPolicy<any> | FieldReadFunction<any>,
	resetPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	updateChoice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateChoicesList?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDatapoint?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDimension?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDimensionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateDisclosureRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	updateIndicator?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMdr?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReviewWorkflowsWorkflow?: FieldPolicy<any> | FieldReadFunction<any>,
	updateReviewWorkflowsWorkflowStage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateStandard?: FieldPolicy<any> | FieldReadFunction<any>,
	updateStandardRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTopic?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUnitType?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUploadFile?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUsersPermissionsRole?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUsersPermissionsUser?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginationKeySpecifier = ('page' | 'pageCount' | 'pageSize' | 'total' | PaginationKeySpecifier)[];
export type PaginationFieldPolicy = {
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCount?: FieldPolicy<any> | FieldReadFunction<any>,
	pageSize?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('choice' | 'choices' | 'choicesList' | 'choicesLists' | 'choicesLists_connection' | 'choices_connection' | 'datapoint' | 'datapoints' | 'datapoints_connection' | 'dimension' | 'dimensionItem' | 'dimensionItems' | 'dimensionItems_connection' | 'dimensions' | 'dimensions_connection' | 'disclosureRequirement' | 'disclosureRequirements' | 'disclosureRequirements_connection' | 'i18NLocale' | 'i18NLocales' | 'i18NLocales_connection' | 'indicator' | 'indicators' | 'indicators_connection' | 'mdr' | 'mdrs' | 'mdrs_connection' | 'me' | 'reviewWorkflowsWorkflow' | 'reviewWorkflowsWorkflowStage' | 'reviewWorkflowsWorkflowStages' | 'reviewWorkflowsWorkflowStages_connection' | 'reviewWorkflowsWorkflows' | 'reviewWorkflowsWorkflows_connection' | 'standard' | 'standardRequirement' | 'standardRequirements' | 'standardRequirements_connection' | 'standards' | 'standards_connection' | 'topic' | 'topics' | 'topics_connection' | 'unit' | 'unitType' | 'unitTypes' | 'unitTypes_connection' | 'units' | 'units_connection' | 'uploadFile' | 'uploadFiles' | 'uploadFiles_connection' | 'usersPermissionsRole' | 'usersPermissionsRoles' | 'usersPermissionsRoles_connection' | 'usersPermissionsUser' | 'usersPermissionsUsers' | 'usersPermissionsUsers_connection' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	choice?: FieldPolicy<any> | FieldReadFunction<any>,
	choices?: FieldPolicy<any> | FieldReadFunction<any>,
	choicesList?: FieldPolicy<any> | FieldReadFunction<any>,
	choicesLists?: FieldPolicy<any> | FieldReadFunction<any>,
	choicesLists_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	choices_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoint?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints?: FieldPolicy<any> | FieldReadFunction<any>,
	datapoints_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	dimension?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionItem?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionItems?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensionItems_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensions?: FieldPolicy<any> | FieldReadFunction<any>,
	dimensions_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureRequirements?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosureRequirements_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	i18NLocale?: FieldPolicy<any> | FieldReadFunction<any>,
	i18NLocales?: FieldPolicy<any> | FieldReadFunction<any>,
	i18NLocales_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	indicator?: FieldPolicy<any> | FieldReadFunction<any>,
	indicators?: FieldPolicy<any> | FieldReadFunction<any>,
	indicators_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	mdr?: FieldPolicy<any> | FieldReadFunction<any>,
	mdrs?: FieldPolicy<any> | FieldReadFunction<any>,
	mdrs_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewWorkflowsWorkflow?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewWorkflowsWorkflowStage?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewWorkflowsWorkflowStages?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewWorkflowsWorkflowStages_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewWorkflowsWorkflows?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewWorkflowsWorkflows_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	standardRequirement?: FieldPolicy<any> | FieldReadFunction<any>,
	standardRequirements?: FieldPolicy<any> | FieldReadFunction<any>,
	standardRequirements_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	standards?: FieldPolicy<any> | FieldReadFunction<any>,
	standards_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	topic?: FieldPolicy<any> | FieldReadFunction<any>,
	topics?: FieldPolicy<any> | FieldReadFunction<any>,
	topics_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	unitType?: FieldPolicy<any> | FieldReadFunction<any>,
	unitTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	unitTypes_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	units?: FieldPolicy<any> | FieldReadFunction<any>,
	units_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadFile?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadFiles_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	usersPermissionsRole?: FieldPolicy<any> | FieldReadFunction<any>,
	usersPermissionsRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	usersPermissionsRoles_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	usersPermissionsUser?: FieldPolicy<any> | FieldReadFunction<any>,
	usersPermissionsUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	usersPermissionsUsers_connection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReviewWorkflowsWorkflowKeySpecifier = ('contentTypes' | 'createdAt' | 'documentId' | 'name' | 'publishedAt' | 'stageRequiredToPublish' | 'stages' | 'stages_connection' | 'updatedAt' | ReviewWorkflowsWorkflowKeySpecifier)[];
export type ReviewWorkflowsWorkflowFieldPolicy = {
	contentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	stageRequiredToPublish?: FieldPolicy<any> | FieldReadFunction<any>,
	stages?: FieldPolicy<any> | FieldReadFunction<any>,
	stages_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReviewWorkflowsWorkflowEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | ReviewWorkflowsWorkflowEntityResponseCollectionKeySpecifier)[];
export type ReviewWorkflowsWorkflowEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReviewWorkflowsWorkflowStageKeySpecifier = ('color' | 'createdAt' | 'documentId' | 'name' | 'publishedAt' | 'updatedAt' | 'workflow' | ReviewWorkflowsWorkflowStageKeySpecifier)[];
export type ReviewWorkflowsWorkflowStageFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	workflow?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReviewWorkflowsWorkflowStageEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | ReviewWorkflowsWorkflowStageEntityResponseCollectionKeySpecifier)[];
export type ReviewWorkflowsWorkflowStageEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReviewWorkflowsWorkflowStageRelationResponseCollectionKeySpecifier = ('nodes' | ReviewWorkflowsWorkflowStageRelationResponseCollectionKeySpecifier)[];
export type ReviewWorkflowsWorkflowStageRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardKeySpecifier = ('createdAt' | 'documentId' | 'isPrivate' | 'logo_base64' | 'name' | 'publishedAt' | 'slug' | 'standard_requirements' | 'standard_requirements_connection' | 'topics' | 'topics_connection' | 'translation' | 'updatedAt' | 'versionNumber' | 'website' | StandardKeySpecifier)[];
export type StandardFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	isPrivate?: FieldPolicy<any> | FieldReadFunction<any>,
	logo_base64?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	standard_requirements?: FieldPolicy<any> | FieldReadFunction<any>,
	standard_requirements_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	topics?: FieldPolicy<any> | FieldReadFunction<any>,
	topics_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	versionNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	website?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | StandardEntityResponseCollectionKeySpecifier)[];
export type StandardEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardRequirementKeySpecifier = ('createdAt' | 'disclosure_requirements' | 'disclosure_requirements_connection' | 'documentId' | 'position' | 'publishedAt' | 'slug' | 'standard' | 'topic' | 'translation' | 'updatedAt' | StandardRequirementKeySpecifier)[];
export type StandardRequirementFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosure_requirements?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosure_requirements_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	topic?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardRequirementEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | StandardRequirementEntityResponseCollectionKeySpecifier)[];
export type StandardRequirementEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StandardRequirementRelationResponseCollectionKeySpecifier = ('nodes' | StandardRequirementRelationResponseCollectionKeySpecifier)[];
export type StandardRequirementRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TopicKeySpecifier = ('children' | 'children_connection' | 'createdAt' | 'description' | 'disclosure_requirements' | 'disclosure_requirements_connection' | 'documentId' | 'locale' | 'localizations' | 'localizations_connection' | 'name' | 'parent' | 'position' | 'publishedAt' | 'slug' | 'standard' | 'standard_requirement' | 'updatedAt' | TopicKeySpecifier)[];
export type TopicFieldPolicy = {
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	children_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosure_requirements?: FieldPolicy<any> | FieldReadFunction<any>,
	disclosure_requirements_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	position?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	standard?: FieldPolicy<any> | FieldReadFunction<any>,
	standard_requirement?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TopicEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | TopicEntityResponseCollectionKeySpecifier)[];
export type TopicEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TopicRelationResponseCollectionKeySpecifier = ('nodes' | TopicRelationResponseCollectionKeySpecifier)[];
export type TopicRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitKeySpecifier = ('createdAt' | 'documentId' | 'identifier' | 'locale' | 'localizations' | 'localizations_connection' | 'name' | 'publishedAt' | 'symbol' | 'unit_type' | 'updatedAt' | UnitKeySpecifier)[];
export type UnitFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations?: FieldPolicy<any> | FieldReadFunction<any>,
	localizations_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	symbol?: FieldPolicy<any> | FieldReadFunction<any>,
	unit_type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | UnitEntityResponseCollectionKeySpecifier)[];
export type UnitEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitRelationResponseCollectionKeySpecifier = ('nodes' | UnitRelationResponseCollectionKeySpecifier)[];
export type UnitRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitTypeKeySpecifier = ('createdAt' | 'documentId' | 'identifier' | 'publishedAt' | 'translation' | 'updatedAt' | UnitTypeKeySpecifier)[];
export type UnitTypeFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UnitTypeEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | UnitTypeEntityResponseCollectionKeySpecifier)[];
export type UnitTypeEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadFileKeySpecifier = ('alternativeText' | 'caption' | 'createdAt' | 'documentId' | 'ext' | 'focalPoint' | 'formats' | 'hash' | 'height' | 'mime' | 'name' | 'previewUrl' | 'provider' | 'provider_metadata' | 'publishedAt' | 'related' | 'size' | 'updatedAt' | 'url' | 'width' | UploadFileKeySpecifier)[];
export type UploadFileFieldPolicy = {
	alternativeText?: FieldPolicy<any> | FieldReadFunction<any>,
	caption?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	ext?: FieldPolicy<any> | FieldReadFunction<any>,
	focalPoint?: FieldPolicy<any> | FieldReadFunction<any>,
	formats?: FieldPolicy<any> | FieldReadFunction<any>,
	hash?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	mime?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	previewUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	provider_metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	related?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadFileEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | UploadFileEntityResponseCollectionKeySpecifier)[];
export type UploadFileEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsCreateRolePayloadKeySpecifier = ('ok' | UsersPermissionsCreateRolePayloadKeySpecifier)[];
export type UsersPermissionsCreateRolePayloadFieldPolicy = {
	ok?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsDeleteRolePayloadKeySpecifier = ('ok' | UsersPermissionsDeleteRolePayloadKeySpecifier)[];
export type UsersPermissionsDeleteRolePayloadFieldPolicy = {
	ok?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsLoginPayloadKeySpecifier = ('jwt' | 'user' | UsersPermissionsLoginPayloadKeySpecifier)[];
export type UsersPermissionsLoginPayloadFieldPolicy = {
	jwt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsMeKeySpecifier = ('blocked' | 'confirmed' | 'documentId' | 'email' | 'id' | 'role' | 'username' | UsersPermissionsMeKeySpecifier)[];
export type UsersPermissionsMeFieldPolicy = {
	blocked?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsMeRoleKeySpecifier = ('description' | 'id' | 'name' | 'type' | UsersPermissionsMeRoleKeySpecifier)[];
export type UsersPermissionsMeRoleFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsPasswordPayloadKeySpecifier = ('ok' | UsersPermissionsPasswordPayloadKeySpecifier)[];
export type UsersPermissionsPasswordPayloadFieldPolicy = {
	ok?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsPermissionKeySpecifier = ('action' | 'createdAt' | 'documentId' | 'publishedAt' | 'role' | 'updatedAt' | UsersPermissionsPermissionKeySpecifier)[];
export type UsersPermissionsPermissionFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsPermissionRelationResponseCollectionKeySpecifier = ('nodes' | UsersPermissionsPermissionRelationResponseCollectionKeySpecifier)[];
export type UsersPermissionsPermissionRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsRoleKeySpecifier = ('createdAt' | 'description' | 'documentId' | 'name' | 'permissions' | 'permissions_connection' | 'publishedAt' | 'type' | 'updatedAt' | 'users' | 'users_connection' | UsersPermissionsRoleKeySpecifier)[];
export type UsersPermissionsRoleFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions_connection?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	users_connection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsRoleEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | UsersPermissionsRoleEntityResponseCollectionKeySpecifier)[];
export type UsersPermissionsRoleEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsUpdateRolePayloadKeySpecifier = ('ok' | UsersPermissionsUpdateRolePayloadKeySpecifier)[];
export type UsersPermissionsUpdateRolePayloadFieldPolicy = {
	ok?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsUserKeySpecifier = ('blocked' | 'confirmed' | 'createdAt' | 'documentId' | 'email' | 'provider' | 'publishedAt' | 'role' | 'updatedAt' | 'username' | UsersPermissionsUserKeySpecifier)[];
export type UsersPermissionsUserFieldPolicy = {
	blocked?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsUserEntityResponseKeySpecifier = ('data' | UsersPermissionsUserEntityResponseKeySpecifier)[];
export type UsersPermissionsUserEntityResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsUserEntityResponseCollectionKeySpecifier = ('nodes' | 'pageInfo' | UsersPermissionsUserEntityResponseCollectionKeySpecifier)[];
export type UsersPermissionsUserEntityResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsersPermissionsUserRelationResponseCollectionKeySpecifier = ('nodes' | UsersPermissionsUserRelationResponseCollectionKeySpecifier)[];
export type UsersPermissionsUserRelationResponseCollectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Choice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChoiceKeySpecifier | (() => undefined | ChoiceKeySpecifier),
		fields?: ChoiceFieldPolicy,
	},
	ChoiceEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChoiceEntityResponseCollectionKeySpecifier | (() => undefined | ChoiceEntityResponseCollectionKeySpecifier),
		fields?: ChoiceEntityResponseCollectionFieldPolicy,
	},
	ChoiceRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChoiceRelationResponseCollectionKeySpecifier | (() => undefined | ChoiceRelationResponseCollectionKeySpecifier),
		fields?: ChoiceRelationResponseCollectionFieldPolicy,
	},
	ChoicesList?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChoicesListKeySpecifier | (() => undefined | ChoicesListKeySpecifier),
		fields?: ChoicesListFieldPolicy,
	},
	ChoicesListEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChoicesListEntityResponseCollectionKeySpecifier | (() => undefined | ChoicesListEntityResponseCollectionKeySpecifier),
		fields?: ChoicesListEntityResponseCollectionFieldPolicy,
	},
	ComponentArApplicationRequirement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentArApplicationRequirementKeySpecifier | (() => undefined | ComponentArApplicationRequirementKeySpecifier),
		fields?: ComponentArApplicationRequirementFieldPolicy,
	},
	ComponentArApplicationRequirementSubChapter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentArApplicationRequirementSubChapterKeySpecifier | (() => undefined | ComponentArApplicationRequirementSubChapterKeySpecifier),
		fields?: ComponentArApplicationRequirementSubChapterFieldPolicy,
	},
	ComponentCommonFootnote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentCommonFootnoteKeySpecifier | (() => undefined | ComponentCommonFootnoteKeySpecifier),
		fields?: ComponentCommonFootnoteFieldPolicy,
	},
	ComponentDrConditionalDatapoints?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentDrConditionalDatapointsKeySpecifier | (() => undefined | ComponentDrConditionalDatapointsKeySpecifier),
		fields?: ComponentDrConditionalDatapointsFieldPolicy,
	},
	ComponentDrDatapointGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentDrDatapointGroupKeySpecifier | (() => undefined | ComponentDrDatapointGroupKeySpecifier),
		fields?: ComponentDrDatapointGroupFieldPolicy,
	},
	ComponentDrDrContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentDrDrContentKeySpecifier | (() => undefined | ComponentDrDrContentKeySpecifier),
		fields?: ComponentDrDrContentFieldPolicy,
	},
	ComponentDrDrContentLevel2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentDrDrContentLevel2KeySpecifier | (() => undefined | ComponentDrDrContentLevel2KeySpecifier),
		fields?: ComponentDrDrContentLevel2FieldPolicy,
	},
	ComponentDrDrContentLevel3?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentDrDrContentLevel3KeySpecifier | (() => undefined | ComponentDrDrContentLevel3KeySpecifier),
		fields?: ComponentDrDrContentLevel3FieldPolicy,
	},
	ComponentDrIndicatorDrivenDatapoints?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentDrIndicatorDrivenDatapointsKeySpecifier | (() => undefined | ComponentDrIndicatorDrivenDatapointsKeySpecifier),
		fields?: ComponentDrIndicatorDrivenDatapointsFieldPolicy,
	},
	ComponentGuidanceGuidance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentGuidanceGuidanceKeySpecifier | (() => undefined | ComponentGuidanceGuidanceKeySpecifier),
		fields?: ComponentGuidanceGuidanceFieldPolicy,
	},
	ComponentI18NRichTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentI18NRichTranslationKeySpecifier | (() => undefined | ComponentI18NRichTranslationKeySpecifier),
		fields?: ComponentI18NRichTranslationFieldPolicy,
	},
	ComponentI18NTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentI18NTranslationKeySpecifier | (() => undefined | ComponentI18NTranslationKeySpecifier),
		fields?: ComponentI18NTranslationFieldPolicy,
	},
	ComponentMdrMdrLevel1?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentMdrMdrLevel1KeySpecifier | (() => undefined | ComponentMdrMdrLevel1KeySpecifier),
		fields?: ComponentMdrMdrLevel1FieldPolicy,
	},
	ComponentMdrMdrLevel2?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentMdrMdrLevel2KeySpecifier | (() => undefined | ComponentMdrMdrLevel2KeySpecifier),
		fields?: ComponentMdrMdrLevel2FieldPolicy,
	},
	ComponentMdrMdrLevel3?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ComponentMdrMdrLevel3KeySpecifier | (() => undefined | ComponentMdrMdrLevel3KeySpecifier),
		fields?: ComponentMdrMdrLevel3FieldPolicy,
	},
	Datapoint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DatapointKeySpecifier | (() => undefined | DatapointKeySpecifier),
		fields?: DatapointFieldPolicy,
	},
	DatapointEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DatapointEntityResponseCollectionKeySpecifier | (() => undefined | DatapointEntityResponseCollectionKeySpecifier),
		fields?: DatapointEntityResponseCollectionFieldPolicy,
	},
	DatapointRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DatapointRelationResponseCollectionKeySpecifier | (() => undefined | DatapointRelationResponseCollectionKeySpecifier),
		fields?: DatapointRelationResponseCollectionFieldPolicy,
	},
	DeleteMutationResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMutationResponseKeySpecifier | (() => undefined | DeleteMutationResponseKeySpecifier),
		fields?: DeleteMutationResponseFieldPolicy,
	},
	Dimension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DimensionKeySpecifier | (() => undefined | DimensionKeySpecifier),
		fields?: DimensionFieldPolicy,
	},
	DimensionEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DimensionEntityResponseCollectionKeySpecifier | (() => undefined | DimensionEntityResponseCollectionKeySpecifier),
		fields?: DimensionEntityResponseCollectionFieldPolicy,
	},
	DimensionItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DimensionItemKeySpecifier | (() => undefined | DimensionItemKeySpecifier),
		fields?: DimensionItemFieldPolicy,
	},
	DimensionItemEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DimensionItemEntityResponseCollectionKeySpecifier | (() => undefined | DimensionItemEntityResponseCollectionKeySpecifier),
		fields?: DimensionItemEntityResponseCollectionFieldPolicy,
	},
	DimensionItemRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DimensionItemRelationResponseCollectionKeySpecifier | (() => undefined | DimensionItemRelationResponseCollectionKeySpecifier),
		fields?: DimensionItemRelationResponseCollectionFieldPolicy,
	},
	DimensionRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DimensionRelationResponseCollectionKeySpecifier | (() => undefined | DimensionRelationResponseCollectionKeySpecifier),
		fields?: DimensionRelationResponseCollectionFieldPolicy,
	},
	DisclosureRequirement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureRequirementKeySpecifier | (() => undefined | DisclosureRequirementKeySpecifier),
		fields?: DisclosureRequirementFieldPolicy,
	},
	DisclosureRequirementEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureRequirementEntityResponseCollectionKeySpecifier | (() => undefined | DisclosureRequirementEntityResponseCollectionKeySpecifier),
		fields?: DisclosureRequirementEntityResponseCollectionFieldPolicy,
	},
	DisclosureRequirementRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DisclosureRequirementRelationResponseCollectionKeySpecifier | (() => undefined | DisclosureRequirementRelationResponseCollectionKeySpecifier),
		fields?: DisclosureRequirementRelationResponseCollectionFieldPolicy,
	},
	I18NLocale?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | I18NLocaleKeySpecifier | (() => undefined | I18NLocaleKeySpecifier),
		fields?: I18NLocaleFieldPolicy,
	},
	I18NLocaleEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | I18NLocaleEntityResponseCollectionKeySpecifier | (() => undefined | I18NLocaleEntityResponseCollectionKeySpecifier),
		fields?: I18NLocaleEntityResponseCollectionFieldPolicy,
	},
	Indicator?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndicatorKeySpecifier | (() => undefined | IndicatorKeySpecifier),
		fields?: IndicatorFieldPolicy,
	},
	IndicatorEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndicatorEntityResponseCollectionKeySpecifier | (() => undefined | IndicatorEntityResponseCollectionKeySpecifier),
		fields?: IndicatorEntityResponseCollectionFieldPolicy,
	},
	IndicatorRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IndicatorRelationResponseCollectionKeySpecifier | (() => undefined | IndicatorRelationResponseCollectionKeySpecifier),
		fields?: IndicatorRelationResponseCollectionFieldPolicy,
	},
	Mdr?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MdrKeySpecifier | (() => undefined | MdrKeySpecifier),
		fields?: MdrFieldPolicy,
	},
	MdrEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MdrEntityResponseCollectionKeySpecifier | (() => undefined | MdrEntityResponseCollectionKeySpecifier),
		fields?: MdrEntityResponseCollectionFieldPolicy,
	},
	MdrRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MdrRelationResponseCollectionKeySpecifier | (() => undefined | MdrRelationResponseCollectionKeySpecifier),
		fields?: MdrRelationResponseCollectionFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	Pagination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginationKeySpecifier | (() => undefined | PaginationKeySpecifier),
		fields?: PaginationFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	ReviewWorkflowsWorkflow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReviewWorkflowsWorkflowKeySpecifier | (() => undefined | ReviewWorkflowsWorkflowKeySpecifier),
		fields?: ReviewWorkflowsWorkflowFieldPolicy,
	},
	ReviewWorkflowsWorkflowEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReviewWorkflowsWorkflowEntityResponseCollectionKeySpecifier | (() => undefined | ReviewWorkflowsWorkflowEntityResponseCollectionKeySpecifier),
		fields?: ReviewWorkflowsWorkflowEntityResponseCollectionFieldPolicy,
	},
	ReviewWorkflowsWorkflowStage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReviewWorkflowsWorkflowStageKeySpecifier | (() => undefined | ReviewWorkflowsWorkflowStageKeySpecifier),
		fields?: ReviewWorkflowsWorkflowStageFieldPolicy,
	},
	ReviewWorkflowsWorkflowStageEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReviewWorkflowsWorkflowStageEntityResponseCollectionKeySpecifier | (() => undefined | ReviewWorkflowsWorkflowStageEntityResponseCollectionKeySpecifier),
		fields?: ReviewWorkflowsWorkflowStageEntityResponseCollectionFieldPolicy,
	},
	ReviewWorkflowsWorkflowStageRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReviewWorkflowsWorkflowStageRelationResponseCollectionKeySpecifier | (() => undefined | ReviewWorkflowsWorkflowStageRelationResponseCollectionKeySpecifier),
		fields?: ReviewWorkflowsWorkflowStageRelationResponseCollectionFieldPolicy,
	},
	Standard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardKeySpecifier | (() => undefined | StandardKeySpecifier),
		fields?: StandardFieldPolicy,
	},
	StandardEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardEntityResponseCollectionKeySpecifier | (() => undefined | StandardEntityResponseCollectionKeySpecifier),
		fields?: StandardEntityResponseCollectionFieldPolicy,
	},
	StandardRequirement?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardRequirementKeySpecifier | (() => undefined | StandardRequirementKeySpecifier),
		fields?: StandardRequirementFieldPolicy,
	},
	StandardRequirementEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardRequirementEntityResponseCollectionKeySpecifier | (() => undefined | StandardRequirementEntityResponseCollectionKeySpecifier),
		fields?: StandardRequirementEntityResponseCollectionFieldPolicy,
	},
	StandardRequirementRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StandardRequirementRelationResponseCollectionKeySpecifier | (() => undefined | StandardRequirementRelationResponseCollectionKeySpecifier),
		fields?: StandardRequirementRelationResponseCollectionFieldPolicy,
	},
	Topic?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TopicKeySpecifier | (() => undefined | TopicKeySpecifier),
		fields?: TopicFieldPolicy,
	},
	TopicEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TopicEntityResponseCollectionKeySpecifier | (() => undefined | TopicEntityResponseCollectionKeySpecifier),
		fields?: TopicEntityResponseCollectionFieldPolicy,
	},
	TopicRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TopicRelationResponseCollectionKeySpecifier | (() => undefined | TopicRelationResponseCollectionKeySpecifier),
		fields?: TopicRelationResponseCollectionFieldPolicy,
	},
	Unit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitKeySpecifier | (() => undefined | UnitKeySpecifier),
		fields?: UnitFieldPolicy,
	},
	UnitEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitEntityResponseCollectionKeySpecifier | (() => undefined | UnitEntityResponseCollectionKeySpecifier),
		fields?: UnitEntityResponseCollectionFieldPolicy,
	},
	UnitRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitRelationResponseCollectionKeySpecifier | (() => undefined | UnitRelationResponseCollectionKeySpecifier),
		fields?: UnitRelationResponseCollectionFieldPolicy,
	},
	UnitType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitTypeKeySpecifier | (() => undefined | UnitTypeKeySpecifier),
		fields?: UnitTypeFieldPolicy,
	},
	UnitTypeEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UnitTypeEntityResponseCollectionKeySpecifier | (() => undefined | UnitTypeEntityResponseCollectionKeySpecifier),
		fields?: UnitTypeEntityResponseCollectionFieldPolicy,
	},
	UploadFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadFileKeySpecifier | (() => undefined | UploadFileKeySpecifier),
		fields?: UploadFileFieldPolicy,
	},
	UploadFileEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadFileEntityResponseCollectionKeySpecifier | (() => undefined | UploadFileEntityResponseCollectionKeySpecifier),
		fields?: UploadFileEntityResponseCollectionFieldPolicy,
	},
	UsersPermissionsCreateRolePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsCreateRolePayloadKeySpecifier | (() => undefined | UsersPermissionsCreateRolePayloadKeySpecifier),
		fields?: UsersPermissionsCreateRolePayloadFieldPolicy,
	},
	UsersPermissionsDeleteRolePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsDeleteRolePayloadKeySpecifier | (() => undefined | UsersPermissionsDeleteRolePayloadKeySpecifier),
		fields?: UsersPermissionsDeleteRolePayloadFieldPolicy,
	},
	UsersPermissionsLoginPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsLoginPayloadKeySpecifier | (() => undefined | UsersPermissionsLoginPayloadKeySpecifier),
		fields?: UsersPermissionsLoginPayloadFieldPolicy,
	},
	UsersPermissionsMe?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsMeKeySpecifier | (() => undefined | UsersPermissionsMeKeySpecifier),
		fields?: UsersPermissionsMeFieldPolicy,
	},
	UsersPermissionsMeRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsMeRoleKeySpecifier | (() => undefined | UsersPermissionsMeRoleKeySpecifier),
		fields?: UsersPermissionsMeRoleFieldPolicy,
	},
	UsersPermissionsPasswordPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsPasswordPayloadKeySpecifier | (() => undefined | UsersPermissionsPasswordPayloadKeySpecifier),
		fields?: UsersPermissionsPasswordPayloadFieldPolicy,
	},
	UsersPermissionsPermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsPermissionKeySpecifier | (() => undefined | UsersPermissionsPermissionKeySpecifier),
		fields?: UsersPermissionsPermissionFieldPolicy,
	},
	UsersPermissionsPermissionRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsPermissionRelationResponseCollectionKeySpecifier | (() => undefined | UsersPermissionsPermissionRelationResponseCollectionKeySpecifier),
		fields?: UsersPermissionsPermissionRelationResponseCollectionFieldPolicy,
	},
	UsersPermissionsRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsRoleKeySpecifier | (() => undefined | UsersPermissionsRoleKeySpecifier),
		fields?: UsersPermissionsRoleFieldPolicy,
	},
	UsersPermissionsRoleEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsRoleEntityResponseCollectionKeySpecifier | (() => undefined | UsersPermissionsRoleEntityResponseCollectionKeySpecifier),
		fields?: UsersPermissionsRoleEntityResponseCollectionFieldPolicy,
	},
	UsersPermissionsUpdateRolePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsUpdateRolePayloadKeySpecifier | (() => undefined | UsersPermissionsUpdateRolePayloadKeySpecifier),
		fields?: UsersPermissionsUpdateRolePayloadFieldPolicy,
	},
	UsersPermissionsUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsUserKeySpecifier | (() => undefined | UsersPermissionsUserKeySpecifier),
		fields?: UsersPermissionsUserFieldPolicy,
	},
	UsersPermissionsUserEntityResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsUserEntityResponseKeySpecifier | (() => undefined | UsersPermissionsUserEntityResponseKeySpecifier),
		fields?: UsersPermissionsUserEntityResponseFieldPolicy,
	},
	UsersPermissionsUserEntityResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsUserEntityResponseCollectionKeySpecifier | (() => undefined | UsersPermissionsUserEntityResponseCollectionKeySpecifier),
		fields?: UsersPermissionsUserEntityResponseCollectionFieldPolicy,
	},
	UsersPermissionsUserRelationResponseCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsersPermissionsUserRelationResponseCollectionKeySpecifier | (() => undefined | UsersPermissionsUserRelationResponseCollectionKeySpecifier),
		fields?: UsersPermissionsUserRelationResponseCollectionFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;